/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useRef, useState } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import styled from "styled-components"
import BeatLoader from "react-spinners/BeatLoader";
import "./switch.css";
import { show, hide } from "react-functional-modal"
import Invoice from "../Invoice/Invoice";
import html2pdf from 'html2pdf.js';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from "moment";
import "../../index.css"
import { FaEye, FaEdit, FaTruck, FaMapMarkerAlt, FaExternalLinkAlt } from "react-icons/fa";
// import * as  ReactModal from "@types/react-modal"
// import "./styles.css";

const { apiEndpoint, baseNodeapiUrl, uploadUrl } = config;
const Pbutton = styled.button
  `
outline: none;
border: none;
margin-left: 18px;
background: #105293;
padding: 3px 5px;

`
const ProviderContainer = styled.div
  `
background: white;
min-width: 60%;
// max-width: 90%;
border: 1px solid rgb(0, 148, 255);
position: relative;
padding: 10px;
border-radius: 20px
`
const ListContainer = styled.div
  `
background: #e3e6f0;
width: 90%;
paddind: 10px;
padding: 10px;
font-size: 14px;
font-weight: 600;
border-radius: 20px
`

const textStyle1 = {
  fontWeight: "600", fontSize: "17px", color: "black"
}

const tableStyle = {
  width: "35%",
  maxWidth: "40%"
}

/* ----------------------------------------------------------------------------------
   Design tokens & shared style objects for the redesigned Order Detail dashboard UI.
   Purely presentational — no business logic lives here.
------------------------------------------------------------------------------------*/
const palette = {
  pageBg: "#eef0f6",
  card: "#ffffff",
  border: "#e8e9f1",
  text: "#111827",
  subtext: "#6b7280",
  label: "#374151",
  teal: "#0f9d78",
  tealSoft: "#e7f7f1",
  indigo: "#4c3fe0",
  indigoDark: "#3a2fc0",
  navy: "#1c1733",
  orange: "#b8770a",
  orangeBg: "#fdf1dd",
  red: "#dc2626",
  redSoft: "#fdecec",
  green: "#16a34a",
};

const S = {
  page: {
    background: palette.pageBg,
    padding: "20px",
    height: "100vh",
    overflow: "hidden",

  },
  grid: {
    display: "flex",
    gap: "20px",
    alignItems: "flex-start",
    flexWrap: "nowrap",
    height: "100%",
  },
  mainCol: {
    flex: "1 1 620px",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    height: "100%",
    overflowY: "auto",
    // paddingRight: "8px",
    scrollbarWidth: "none",
  },
  sideCol: {
    flex: "0 1 300px",
    minWidth: "300px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    height: "100%",
    overflowY: "auto",
  },
  card: {
    background: palette.card,
    border: `1px solid ${palette.border}`,
    borderRadius: "5px",
    padding: "22px",
    boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
  },
  eyebrow: { fontSize: "11px", fontWeight: 700, letterSpacing: "0.08em", color: palette.subtext, textTransform: "uppercase", marginBottom: "4px" },
  orderTitle: { fontSize: "20px", fontWeight: 700, color: palette.text },
  orderIdMono: { fontFamily: "monospace", fontSize: "14px", color: palette.subtext, fontWeight: 500 },
  headerRow: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: "12px" },
  otpBadge: {
    display: "inline-flex", alignItems: "center", gap: "6px",
    background: palette.orangeBg, color: palette.orange, fontWeight: 700,
    fontSize: "13px", padding: "8px 16px", borderRadius: "999px", whiteSpace: "nowrap",
  },
  otpDot: { width: "6px", height: "6px", borderRadius: "50%", background: palette.orange, display: "inline-block" },
  sectionTitle: { display: "flex", alignItems: "center", gap: "8px", marginBottom: "16px" },
  sectionBar: { width: "4px", height: "16px", borderRadius: "2px", background: palette.teal, display: "inline-block" },
  sectionTitleText: { color: palette.teal, fontWeight: 700, fontSize: "15px" },
  rowLine: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 0", borderBottom: `1px solid ${palette.border}` },
  rowLabel: { color: palette.subtext, fontSize: "14px" },
  rowValue: { color: palette.text, fontSize: "14px", fontWeight: 600, textAlign: "right" },
  fieldLabel: { fontSize: "13px", fontWeight: 600, color: palette.label, marginBottom: "6px", display: "block" },
  select: {
    width: "100%", padding: "10px 12px", borderRadius: "5px", border: `1px solid ${palette.border}`,
    background: "#fff", fontSize: "14px", color: palette.text,
  },
  input: {
    width: "100%", padding: "10px 12px", borderRadius: "5px", border: `1px solid ${palette.border}`,
    background: "#fff", fontSize: "14px", color: palette.text,
  },
  primaryBtn: {
    background: palette.indigo, color: "#fff", border: "none", borderRadius: "5px",
    padding: "10px 18px", fontWeight: 600, fontSize: "14px", cursor: "pointer",
  },
  secondaryBtn: {
    background: "#fff", color: palette.text, border: `1px solid ${palette.border}`, borderRadius: "5px",
    padding: "10px 18px", fontWeight: 600, fontSize: "14px", cursor: "pointer",
  },
  dangerOutlineBtn: {
    background: "#fff", color: palette.red, border: `1px solid #f3c6c6`, borderRadius: "5px",
    padding: "10px 18px", fontWeight: 600, fontSize: "14px", cursor: "pointer",
  },
  quickActionPrimary: {
    width: "100%", background: palette.indigo, color: "#fff", border: "none", borderRadius: "5px",
    padding: "12px 16px", fontWeight: 600, fontSize: "14px", cursor: "pointer", marginBottom: "10px",
  },
  quickActionSecondary: {
    width: "100%", background: "#fff", color: palette.text, border: `1px solid ${palette.border}`, borderRadius: "5px",
    padding: "12px 16px", fontWeight: 600, fontSize: "14px", cursor: "pointer", marginBottom: "10px",
  },
  quickActionDanger: {
    width: "100%", background: "#fff", color: palette.red, border: `1px solid #f3c6c6`, borderRadius: "5px",
    padding: "12px 16px", fontWeight: 600, fontSize: "14px", cursor: "pointer",
  },
  grandBox: { background: palette.navy, color: "#fff", borderRadius: "5px", padding: "22px" },
  grandLabel: { fontSize: "11px", letterSpacing: "0.08em", color: "rgba(255,255,255,0.6)", fontWeight: 700, marginBottom: "6px" },
  grandValue: { fontSize: "30px", fontWeight: 800, marginBottom: "4px" },
  grandSub: { fontSize: "13px", color: "rgba(255,255,255,0.65)", marginBottom: "14px" },
  statusPill: { display: "inline-block", background: "rgba(255,255,255,0.12)", padding: "5px 12px", borderRadius: "999px", fontSize: "12px", fontWeight: 600, marginBottom: "14px" },
  grandRow: { display: "flex", justifyContent: "space-between", padding: "8px 0", borderTop: "1px solid rgba(255,255,255,0.12)", fontSize: "13px" },
  customerRow: { display: "flex", gap: "10px", alignItems: "flex-start", padding: "10px 0" },
  customerIcon: { width: "28px", height: "28px", borderRadius: "8px", background: palette.tealSoft, color: palette.teal, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: "13px" },
  customerLabel: { fontSize: "13px", fontWeight: 600, color: palette.text },
  customerSub: { fontSize: "12px", color: palette.subtext },
  itemRow: { display: "flex", gap: "16px", padding: "16px 0", borderBottom: `1px solid ${palette.border}` },
  itemImgWrap: { width: "72px", height: "72px", borderRadius: "12px", background: "#eef0fb", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0 },
  itemMeta: { fontSize: "13px", color: palette.subtext, display: "flex", gap: "12px", flexWrap: "wrap" },
  imeiWrap: { display: "flex", alignItems: "center", gap: "8px", marginTop: "8px" },
  imeiCheckBtn: {
    width: "38px", height: "38px", borderRadius: "10px", border: `1px solid ${palette.border}`,
    background: "#fff", color: palette.teal, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
  },
  noteBar: { display: "flex", gap: "8px", alignItems: "flex-start", background: palette.orangeBg, color: "#92640a", padding: "12px 14px", borderRadius: "10px", fontSize: "13px", margin: "14px 0" },
  stepWrap: { display: "flex", alignItems: "flex-start", width: "100%" },
  stepDot: (state) => ({
    width: "26px", height: "26px", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: "13px", fontWeight: 700, flexShrink: 0,
    background: state === "done" ? palette.teal : state === "active" ? "#fff" : "#fff",
    color: state === "done" ? "#fff" : state === "active" ? palette.indigo : "#c3c6d4",
    border: state === "active" ? `2px solid ${palette.indigo}` : state === "done" ? "none" : `2px solid ${palette.border}`,
  }),
  stepLine: (done) => ({ flex: 1, height: "2px", background: done ? palette.teal : palette.border, marginTop: "13px" }),
  stepLabel: { fontSize: "13px", fontWeight: 700, color: palette.text, marginTop: "8px" },
  stepSub: { fontSize: "12px", color: palette.subtext, marginTop: "2px" },
  toggleTrack: (on) => ({
    width: "38px", height: "22px", borderRadius: "999px", background: on ? palette.indigo : "#d7dae3",
    position: "relative", display: "inline-block", cursor: "pointer", flexShrink: 0,
  }),
  toggleThumb: (on) => ({
    width: "16px", height: "16px", borderRadius: "50%", background: "#fff", position: "absolute",
    top: "3px", left: on ? "19px" : "3px", transition: "left 0.15s ease",
  }),
};

const SectionTitle = ({ children }) => (
  <div style={S.sectionTitle}>
    <span style={S.sectionBar} />
    <span style={S.sectionTitleText}>{children}</span>
  </div>
);

/* ---------------------------------------------------------------------------
   Logistic-order helpers — ported from the RN OrderDetailsScreen so the
   web "Logistics — On Network" section reads the same shape and the eye
   modal renders straight from the row (no extra /order/:id call).
--------------------------------------------------------------------------- */
const parseMaybeJson = (value) => {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  if (!trimmed || (trimmed[0] !== "{" && trimmed[0] !== "[")) return value;
  try {
    return JSON.parse(trimmed);
  } catch {
    return value;
  }
};

const normalizeLogisticRow = (row) => {
  if (!row || typeof row !== "object") return row;
  const out = { ...row };
  ["provider", "items", "billing", "fulfillments", "quote", "payment", "logistics"].forEach((key) => {
    if (key in out) out[key] = parseMaybeJson(out[key]);
  });
  return out;
};

const formatOndcAddress = (address) => {
  if (!address || typeof address !== "object") {
    return typeof address === "string" ? address : "";
  }
  return [
    address.name,
    address.building,
    address.locality,
    address.street,
    address.city,
    address.state,
    address.area_code,
    address.country,
  ]
    .map((p) => (p == null ? "" : String(p).trim()))
    .filter(Boolean)
    .join(", ");
};

const logisticStatePill = (state) => {
  const s = String(state || "").toLowerCase();
  if (s.includes("cancel")) return { bg: "#FDE9E9", fg: "#B91C1C" };
  if (s.includes("deliver")) return { bg: "#E1F5EE", fg: "#1D9E75" };
  if (s.includes("transit") || s.includes("pick")) return { bg: "#E0F2FE", fg: "#0369A1" };
  return { bg: "#FFF3EB", fg: "#B26A00" };
};

const isLogisticCancelled = (row) => {
  const state = String(row?.logistics?.state || row?.order_state || "").toLowerCase();
  return (
    state.includes("cancel") ||
    !!row?.logistics?.cancelled_at ||
    !!row?.logistics?.cancellation?.reason_id
  );
};

const orderDetail = () => {
  const [showPop, setShowPop] = useState(false);

  const toggle = (e) => {
    e.preventDefault();
    setShowPop(true);
  };

  let params = useParams();
  const { id: order_id } = params;
  const [alldetails, setalldetails] = useState([]);
  // console.log("all details-------------", alldetails);
  const decoded = tokenDecode();
  const { data } = decoded;
  const { permission: { order }, } = data;
  const isAdmin = Number(data?.user?.seller_id) === 1;
  const [isLoading, setIsLoading] = useState(false);

  const [updateOrder_, setUpdateOrder_] = useState({
    order_id: "",
    tracking_url: "",
    order_state: "",
  });
  const [orderDetail, setorderDetail] = useState([]);
  const [_orderDetail, _setorderDetail] = useState({
    billing_address: "",
    contact_number: "",
    created_at: "",
    email: "",
    id: "",
    name: "",
    order_id: "",
    order_state: "",
    provider_id: "",
    shipping_address: "",
    status: "",
    total_price: 0,
    return_amount: 0,
  });
  console.log("_orderDetail--->", _orderDetail)
  const [orderState, setOrderState] = useState({
    order_id,
    order_state: "",
    fulfillment_state: "",
    tracking_url: "",
  });

  // Fulfillment steps (GET /order-state-fulfillments) + network-logistics flag.
  // Declared here (before the derived step vars further down) to avoid a TDZ error.
  const [fulfillmentList, setFulfillmentList] = useState([]);
  const [updatingFulfillment, setUpdatingFulfillment] = useState(false);
  const [networkLogistics, setNetworkLogistics] = useState(true);

  const [isChecked, setisChecked] = useState("");
  const [cancelvalue, setCancelvalue] = useState("");
  const [cancelPartialreson, setCancelPartialreson] = useState("");
  const [showdat, setotpdat] = useState("")
  const [logisticCharges, setlogisticCharges] = useState("")
  let rawdata;
  const [orderCancle, setOrderCancle] = useState({
    order_id,
    order_status: "Created",
    product_id: [],
  });

  const [addButton, setaddButton] = useState(true);
  const [sendingOrderStatus, setsendingOrderStatus] = useState(false);


  const [orderStatus, setorderStatus] = useState([
    "Created",
    "Accepted",
    "In-progress",
    "Completed",
    // "Cancelled",
    // "Returned",
  ]);

  const steps = [
    'Order Picked Up',
    'In-Transit',
    'Delivered',
  ];

  const getorderDetails = async (order_id) => {
    // debugger
    setIsLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getsellerorder`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {
          order_id,
        },
      });
      // console.log("order detail ->------   ", JSON.parse(data.data[0]?.quote));
      // console.log("order state ->------   ", data.data[0].order_state);

      console.log("order state ->------ tryinf   ", data.data[0]);
      setNetworkLogistics(data?.warehouse?.[0]?.network_logistics ?? true);
      const fulfillments = JSON.parse(data.data[0].fulfillments);

      setotpdat(fulfillments?.[0]?.end?.authorization?.token);

      // console.log("OTP Token:", tokenfoshow)
      if (data.status === 200) {
        const orderRecord = data.data?.[0] || {};
        setIsLoading(false);
        setorderDetail(data.products);
        setOrderCancle(data.products);
        setInvoiceHolder({
          path: data.data[0].invoice !== null ? data.data[0].invoice : "",
          origin: data.data[0].invoice !== null ? "database" : "manual",
        });
        setlogisticCharges(JSON.parse(data.data[0]?.quote));
        setalldetails(data);
        let assignmentHistory = [];
        try {
          assignmentHistory = Array.isArray(orderRecord.assignment_history)
            ? orderRecord.assignment_history
            : JSON.parse(orderRecord.assignment_history || "[]");
        } catch (error) {
          assignmentHistory = [];
        }
        const latestAssignment = assignmentHistory[assignmentHistory.length - 1] || {};
        const assignedRiderId = orderRecord.delivered_by ?? latestAssignment.rider_id;
        if (assignedRiderId || latestAssignment.rider_name || orderRecord.rider_phone) {
          setAssignedRider({
            rider_id: assignedRiderId,
            rider_name: latestAssignment.rider_name || orderRecord.rider_name || "",
            rider_whatsapp_number: latestAssignment.rider_phone || orderRecord.rider_phone || "",
          });
          if (assignedRiderId) setSelectedRiderId(String(assignedRiderId));
        }
        let totalP = 0;
        data.products.forEach((item) => {
          totalP += parseFloat(item?.price);
        });
        setProducts(
          data.products.map((item) => ({
            ...item,
            imei_number: item.imei_number || "",
            imei_submitted: !!(item.imei_number && item.imei_number.trim() !== ""),
          }))
        );
        const imeiAlreadySubmitted = data.products
          ?.filter((item) => item.product_name !== "Delivery charges")
          ?.every((item) => item.imei_number && item.imei_number.trim() !== "");
        setImeiSubmitted(imeiAlreadySubmitted);
        if (data.data[0].order_state !== "") {
          const index = orderStatus.indexOf(data.data[0].order_state);
          if (index !== -1) {
            setorderStatus(orderStatus.slice(index));
          }
        }
        setOrderState({
          ...orderState,
          order_state: data.data[0]?.order_state,
          tracking_url: data.products[0]?.tracking_url,
          fulfillment_state: data.products[0]?.fulfillment_state,
        });

        setUpdateOrder_({
          ...updateOrder_,
          order_id: data.data[0]?.order_id,
          tracking_url: data.data[0]?.tracking_url,
          order_state: data.data[0]?.order_state,
        });

        _setorderDetail({
          ..._orderDetail,
          ...data.data[0],
          return_amt:
            JSON.parse(data.data[0]?.order_total) -
            data.data[0].return_amount,
          total_price: JSON.parse(data.data[0].order_total),
          billing_address: JSON.parse(data.data[0]?.billing),
          shipping_address: JSON.parse(data.data[0]?.fulfillments),
        });

        rawdata = data.products.map((item) => ({
          item_id: item.product_id,
          order_status: orderState.order_state,
          qty: cancelvalue,
        }));

        orderCancle.product_id = Object.assign(rawdata);

        setOrderCancle(orderCancle);
      }

    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  };

  console.log("alldetails------------>", alldetails)

  //logistic
  const [logisticData, setLogisticData] = useState([]);
  console.log("logisticData--->", logisticData)
  const getLogisticOrderClient = async () => {
    try {
      const response = await axios({
        url: `${baseNodeapiUrl}/admin/api/logistic-order/client/${order_id}`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
      });
      console.log("response----", response);
      if (response?.data?.status == 200 && Array.isArray(response?.data?.data)) {
        setLogisticData(response.data.data.map(normalizeLogisticRow));
      } else {
        setLogisticData([])
      }

      console.log("logistic-order client ------------>", data);
    } catch (error) {
      console.log("logistic-order client error", error);
    }
  };

  //cancel

  const [isCancelling, setIsCancelling] = useState(false);

  // const [cancelledLogisticIds, setCancelledLogisticIds] = useState([]);

  // The full logistic row picked from the table (drives both the eye + cancel modals).
  const [selectedLogisticRow, setSelectedLogisticRow] = useState(null);

  const handleCancelOrder = async () => {
    if (!selectedLogisticType) {
      toast.error("Please select a cancellation reason");
      return;
    }
    // Cancel is keyed by the LSP logistics order id (logistics.order_id),
    // e.g. "mfnb_rdhh6v2n" — not the ONDC client order_id.
    const cancelOrderId =
      selectedLogisticRow?.logistics?.order_id || selectedLogisticRow?.order_id;
    if (!cancelOrderId) {
      toast.error("No logistic order to cancel");
      return;
    }

    try {
      setIsCancelling(true);

      const { data } = await axios({
        url: `${baseNodeapiUrl}/pro-route/v1/cancel`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {
          order_id: cancelOrderId,
          cancellation_reason_id: selectedLogisticType,
        },
      });

      console.log("Order cancelled:", data);
      toast.success("Logistic order cancelled successfully!");

      setShowLogisticEditModal(false);
      setSelectedLogisticType("");
      getLogisticOrderClient();
    } catch (error) {
      console.error("Error cancelling order:", error);
      toast.error("Failed to cancel logistic order !");
    } finally {
      setIsCancelling(false);
    }
  };

  const updateOrder = async (product_id) => {
    try {

      const getItem = orderDetail.find(
        (item) => item?.product_id === product_id
      );

      const { data } = await axios({
        url: `${apiEndpoint}/updateorderstatus`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: getItem,
      });


      if (data.message === "flag1") {
        toast.success("Item status updated !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log("yess", error);

      // console.log("update error", error);
      // toast.error("404 error !", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      // });

      // window.location.reload();
    }
  };
  const updateOrderChangeHandler = (e, index) => {
    // setUpdateOrder_({ ...updateOrder_, [e.target.name]: e.target.value })
    // console.log(e.target.value, "index---", e.target.name, index);
    const newUpdate = orderDetail;
    newUpdate[index][e.target.name] = e.target.value;
    // console.log(newUpdate, "newUpdate");

    setorderDetail([...newUpdate]);
  };
  const updateThisOrder = async (override) => {
    // `override` (an object, not an event) lets the "Mark as <next step>" button
    // pass the next fulfillment step + its matching order_state directly instead
    // of waiting for async setState.
    const merged = override && !override.nativeEvent && !override.target ? override : {};
    const payload = { ...orderState, ...merged };
    try {
      setUpdatingFulfillment(true);

      const { data } = await axios({
        url: `${apiEndpoint}/updateorderstatus`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: payload,
      });
      console.log("orderState", payload);

      if (data.status === 200) {
        setOrderState((prev) => ({ ...prev, ...payload }));
        getorderDetails(order_id);

        const index = orderStatus.indexOf(payload.order_state);
        if (index !== -1) {
          setorderStatus(orderStatus.slice(index));
        }


        toast.success("Order updated successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error("Something went wrong 500 !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setUpdatingFulfillment(false);
    }
  };

  // The API returns "Pending" twice (Created + Accepted). Keep each fulfillment
  // name once, keeping the higher order state, then order the steps by
  // order_states_id — status can only move one step forward at a time.
  const dedupedFulfillments = Object.values(
    (fulfillmentList || []).reduce((acc, r) => {
      const existing = acc[r.fulfillment_name];
      if (!existing || Number(r.order_states_id) > Number(existing.order_states_id)) {
        acc[r.fulfillment_name] = r;
      }
      return acc;
    }, {})
  );
  const orderedFulfillments = dedupedFulfillments
    .slice()
    .sort((a, b) => Number(a.order_states_id) - Number(b.order_states_id));

  // Current step is matched on BOTH the order state and the fulfillment name, so
  // an order still "Created" never counts as past "Pending" (Accepted).
  const currentFulfillmentIndex = orderedFulfillments.findIndex(
    (r) =>
      r.fulfillment_name === orderState.fulfillment_state &&
      r.status_name === orderState.order_state
  );
  const nextFulfillmentStep = orderedFulfillments[currentFulfillmentIndex + 1] || null;

  // The "Pending" step that belongs to Accepted is shown as "Accepted"; the value
  // sent to the backend stays "Pending".
  const stepDisplayName = (step) =>
    step?.status_name === "Accepted" && step?.fulfillment_name === "Pending"
      ? "Accepted"
      : step?.fulfillment_name;

  const advanceFulfillment = () => {
    if (!nextFulfillmentStep) return;
    updateThisOrder({
      fulfillment_state: nextFulfillmentStep.fulfillment_name,
      order_state: nextFulfillmentStep.status_name,
    });
  };

  const cancleQty = (item, setCancelvalue) => {
    item.qty = setCancelvalue;
    // setCancelvalue(cancelvalue);
    // console.log("value", item.qty);
  };
  const cancleReason = (item, setCancelPartialreson) => {
    item.reason = setCancelPartialreson;
    // setCancelPartialreson(cancelPartialreson);
    // console.log("reason", item.reason);
  };
  const cancleChecked = (item, setisChecked) => {
    item.Checked = setisChecked;
    // setCancelPartialreson(cancelPartialreson);
    // console.log("Checked", item.Checked);
  };

  const [cancelQuantityl, setcancelQuantityl] = useState("")
  const [reasonCode, setreasonCode] = useState("")
  const [cancellingProduct, setcancellingProduct] = useState("")
  const [showGreaterValueAlert, setshowGreaterValueAlert] = useState(false)
  const [showEnterValueAlert, setshowEnterValueAlert] = useState(false)
  const [showCancelQuantityGreaterthenOrderQuantity, setshowCancelQuantityGreaterthenOrderQuantity] = useState(false)

  const cancleUpdate = (
    cancelvalue,
    cancelPartialreson,
    item,
    item_id,
    order_status
  ) => {
    // e.preventDefault();
    // console.log("302 orderCancle", orderCancle);

    //line 288 issue

    // const newrawdata = orderDetail.map((item, i) => ({
    //   item_id: item_id,
    //   order_status: orderState.order_state,
    //   qty: item.qty,
    //   reason: item.reason,
    // }));
    const newrawdata = [
      {
        item_id: item_id,
        order_status: order_status,
        cancel_quantity: item.qty,
        reason_code: item.reason,
      },
    ];
    // setOrderCancle({...ordercancel,order_status:order_status})
    // console.log("line 294", newrawdata);
    orderCancle.product_id = Object.assign({}, newrawdata);
    // console.log("line 297", orderCancle);
  };
  // const cancelPartial = async (e) => {
  //   // console.log("line 307", orderCancle);
  //   // const id = toast.loading("Please wait...");
  //   try {
  //     // console.log("orderState---->", orderState);
  //     const response = await axios({
  //       url: `${apiEndpoint}/sellerordercancel`,
  //       method: "POST",
  //       headers: {
  //         "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
  //       },
  //       data: orderCancle,
  //     });
  //     if (response.status === 200) {
  //       toast.success("Order cancel updated !", {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //       });
  //     } else {
  //       // console.log("response for cancelation", response);
  //       toast.error("Something went wrong !", {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //       });
  //     }
  //   } catch (error) {
  //     console.error(" error 784", error);
  //     toast.error("Something went wrong !", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //     });
  //   }
  // };
  //faedit
  const [showLogisticEditModal, setShowLogisticEditModal] = useState(false);

  const [selectedLogisticType, setSelectedLogisticType] = useState("");

  const [showLogisticEyeModal, setShowLogisticEyeModal] = useState(false);
  const [selectedType, setSelectedType] = useState("");

  const getLogisticOrderDetails = async (orderId) => {
    try {
      setEyeLoading(true);

      const response = await axios({
        method: "GET",
        url: `${baseNodeapiUrl}/admin/api/logistic-order/order/${orderId}`,
      });

      console.log(response.data);
      setLogisticEyeData(response.data?.data);
    } catch (error) {
      console.log(error);
    } finally {
      setEyeLoading(false);
    }
  };

  const [logisticEyeData, setLogisticEyeData] = useState({});
  const [eyeLoading, setEyeLoading] = useState(false);

  const [imeiSubmitted, setImeiSubmitted] = useState(false);

  const cancelPartial = async (e, item) => {
    setcancellingProduct(item.id)
    let payload = {
      "order_id": orderCancle?.order_id,
      "order_status": orderState.order_state,
      "product_id": {
        "0": {
          "item_id": item.product_id,
          "order_status": orderState.order_state,
          "cancel_quantity": cancelQuantityl,
          "reason_code": reasonCode
        }
      }
    }
    // console.log(cancelQuantityl, reasonCode)
    if (cancelQuantityl <= item.quantity) {
      if (reasonCode !== "" && cancelQuantityl !== "") {
        // alert()
        try {
          const response = await axios({
            url: `${apiEndpoint}/sellerordercancel`,
            method: "POST",
            headers: {
              "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
            },
            data: payload,
          });
          if (response.status === 200) {
            setcancellingProduct("");
            getorderDetails(order_id);
            setcancelQuantityl("")
            setreasonCode("")
            toast.success("Order cancel updated !", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            // console.log("response for cancelation", response);
            setcancellingProduct("")
            toast.error("Something went wrong !", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        } catch (error) {
          console.error(" error 784", error);
          setcancellingProduct("")
          toast.error("Something went wrong !", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } else {
        setcancellingProduct("")
        // alert("Please enter cancel quantity and reason for cancel")
        setshowEnterValueAlert(true)
        setTimeout(() => {
          setshowEnterValueAlert(false)
        }, 4000);
      }
    } else {
      setcancellingProduct("")
      setshowCancelQuantityGreaterthenOrderQuantity(true)
      setTimeout(() => {
        setshowCancelQuantityGreaterthenOrderQuantity(false)
      }, 4000);
      // alert("Cancel quantity price cannot be greater than Order Quantity")
    }
  };

  useEffect(() => {
    // getorderDetails runs first; the logistic-order client GET call is
    // fired only after getorderDetails has finished (success or fail),
    // exactly as requested — no existing function was modified.
    (async () => {
      await getorderDetails(order_id);
      await getLogisticOrderClient();
    })();
    getFulfillmentOptions();
    getAssignedRider();
    window.scrollTo(0, 0)
    // console.log(_orderDetail.order_state, "<-----------_orderDetail.order_state ")
  }, []);

  // -------------------- Fulfillment steps (order-state-fulfillments) --------------------
  // Rows: { id, order_states_id, status_name, fulfillment_name }. The UI shows only
  // the fulfillment_name; when a step is applied we also send its status_name as
  // order_state so the backend still receives both together.
  // (fulfillmentList / updatingFulfillment / networkLogistics state is declared
  // near the top with the other useState calls.)
  const getFulfillmentOptions = async () => {
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/order-state-fulfillments`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
      });
      const rows = Array.isArray(data) ? data : data?.data || [];
      setFulfillmentList(Array.isArray(rows) ? rows : []);
    } catch (error) {
      console.log("getFulfillmentOptions error", error?.response?.data || error?.message);
    }
  };

  // -------------------- Delivery Rider (invlrider) --------------------
  const [riderList, setRiderList] = useState([]);
  const [riderListLoading, setRiderListLoading] = useState(false);
  const [selectedRiderId, setSelectedRiderId] = useState("");
  const [assigningRider, setAssigningRider] = useState(false);
  const [assignedRider, setAssignedRider] = useState(null);
  const [riderLoading, setRiderLoading] = useState(false);

  const riderToastOpts = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  const fetchRiderList = async (providerId) => {
    if (!providerId) {
      setRiderList([]);
      return;
    }

    try {
      setRiderListLoading(true);
      const { data } = await axios({
        url: `${baseNodeapiUrl}/invlrider/get-riders-by-provider`,
        method: "GET",
        params: { provider_id: providerId },
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
      });
      if (data.success) {
        setRiderList(data.data || []);
      }
    } catch (error) {
      console.log("error fetching riders", error);
    } finally {
      setRiderListLoading(false);
    }
  };

  useEffect(() => {
    fetchRiderList(_orderDetail?.provider_id);
  }, [_orderDetail?.provider_id]);

  // Currently assigned rider for this order (POST /invlrider/ordersrider).
  const getAssignedRider = async () => {
    try {
      setRiderLoading(true);
      const { data } = await axios({
        url: `${baseNodeapiUrl}/invlrider/ordersrider`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: { order_id },
      });
      const result = data?.data ?? data;
      const rider = Array.isArray(result) ? result[0] : result;
      // Keep the assignment found in the order details response if this endpoint
      // returns an empty list or a partial record for admin sessions.
      const hasRider = rider && (
        rider.name || rider.rider_name || rider.rider_id || rider.id ||
        rider.delivered_by || rider.rider_phone || rider.whatsapp_number
      );
      if (hasRider) {
        setAssignedRider(rider);
        setSelectedRiderId(
          String(rider.rider_id ?? rider.id ?? rider.delivered_by ?? "")
        );
      }
    } catch (error) {
      console.log("getAssignedRider error", error?.response?.data || error?.message);
    } finally {
      setRiderLoading(false);
    }
  };

  const assignRiderHandler = async () => {
    if (!selectedRiderId) {
      toast.error("Please select a rider first!", riderToastOpts);
      return;
    }
    try {
      setAssigningRider(true);
      const { data } = await axios({
        url: `${baseNodeapiUrl}/invlrider/assignrider`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        ...(isAdmin && _orderDetail?.provider_id
          ? { params: { provider_id: _orderDetail.provider_id } }
          : {}),
        data: { order_id, rider_id: Number(selectedRiderId) },
      });
      if (data.success) {
        toast.success("Rider assigned successfully!", riderToastOpts);
        await getorderDetails(order_id);
      } else {
        toast.error(data.message || "Failed to assign rider!", riderToastOpts);
      }
    } catch (error) {
      toast.error("Something went wrong while assigning rider!", riderToastOpts);
    } finally {
      setAssigningRider(false);
    }
  };


  // if (_orderDetail.order_state !== "") {
  //     const index = orderStatus.indexOf(_orderDetail.order_state);
  //     if (index !== -1) {
  //       setorderStatus(orderStatus.slice(index));
  //     }
  //   }
  // console.log("orderDetails---->", _orderDetail);
  // console.log("orderStatus---->", orderStatus);
  const [cancelpopup, setcancelpopup] = useState(false);
  const [selectedStatus, setselectedStatus] = useState();
  const cancelbtn = () => {
    setcancelpopup(true);
    // console.log("cancelPopup");
  };

  const [cancelreson, setcancelreson] = useState("");

  const cancelReasonStatement = [
    {
      text: "Price of one or more items have changed due to which buyer was asked to make additional payment",
      code: "001",
      show: false,
    },
    {
      text: "One or more items in the Order not available",
      code: "002",
      show: true
    },
    {
      text: "Product available at lower than order price",
      code: "003",
      show: false,
    },
    {
      text: "Order in pending shipment / delivery state for too long",
      code: "004"
    },
    {
      text: "Merchant rejected the order",
      code: "005",
      show: true
    },
    {
      text: "Order not shipped as per buyer app SLA",
      code: "006",
      show: false,
    },
    {
      text: "Order not ready for pickup",
      code: "008",
      show: false,
    },
    {
      text: "Wrong product delivered",
      code: "009",
      show: false,
    },
    {
      text: "Buyer wants to modify details",
      code: "010",
      show: false,
    },
    {
      text: "Buyer not found or cannot be contacted",
      code: "011",
      show: true
    },
    {
      text: "Buyer does not want product any more",
      code: "012",
      show: true
    },
    {
      text: "Buyer refused to accept delivery",
      code: "013",
      show: true
    },
    {
      text: "Address not found",
      code: "014",
      show: true
    },
    {
      text: "Buyer not available at location",
      code: "015",
      show: true
    },
    {
      text: "Accident / rain / strike / vehicle issues",
      code: "016",
      show: false,
    },
    {
      text: "Order delivery delayed or not possible",
      code: "017",
      show: false,
    },
    {
      text: "Delivery pin code not serviceable",
      code: "018",
      show: true
    },
    {
      text: "Pickup pin code not serviceable",
      code: "019",
      show: true
    },
    {
      text: " Order lost in transit",
      code: "020",
      show: true
    },
  ]
  const changeReturnStatus = (selectedStatus) => {
    // console.log("selectedStatus", selectedStatus);
    // istatus = selectedStatus;
    setcancelreson(selectedStatus);
  };

  const ordercancel = async () => {
    // console.log("cancel", cancelreson);
    // console.log("orderCancel hit");

    const statusData = {
      order_id: order_id,
      reason_code: cancelreson,
    };

    try {
      const response = await axios({
        method: "post",
        url: `${baseNodeapiUrl}/unsolicated_cancel`,
        headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
        data: statusData,
      })
        .then(function (response) {
          // console.log("response 173", response);
          toast.success("Order Cancelled")
          setcancelpopup(false);
        })
        .catch(function (error) {
          console.log("error 176", error);
          toast.error("Something Went Wrong!");
        })
        .finally(function () {
          // console.log("response   // always executed 179");
        });
    } catch (error) {
      console.error(" error 784", error);
    }
  };

  // ---------------------------------- Code functions for logistics Start------------------------------------------------

  const [selectProvider, setselectProvider] = useState(null);
  const [providerPayload, setproviderPayload] = useState({
    transaction_id: "",
    message_id: ""
  })
  const [providersData, setprovidersData] = useState([])
  const [submitData, setSubmitData] = useState([])
  const controller = useRef(false)
  const [issChecked, setIssChecked] = useState([]);
  const [isinitRunning, setisinitRunning] = useState(false);
  const [WeightSection, setWeightSection] = useState(false);

  const [wAndD, setwAndD] = useState({
    weight: '',
    weightUnit: "",
    length: '',
    width: '',
    height: '',
    dimensionUnit: ""
  })



  // useEffect(() => {
  //   setTimeout(() => {
  //     getProviders()
  //   }, 3000);
  // }, [providerPayload])
  // useEffect(() => {
  //   if (controller.current !== false) {
  //     open()
  //   }


  // }, [submitData])

  function WandChangeHandler(e) {
    setwAndD({ ...wAndD, [e.target.name]: e.target.value })
  }

  async function getProvidersPayload() {
    console.log("form data", wAndD)
    let dataTosend = {
      order_id: order_id,
      weight: {
        unit: wAndD.weightUnit,
        value: parseInt(wAndD.weight)
      },
      dimensions: {
        length: {
          unit: wAndD.dimensionUnit,
          value: parseInt(wAndD.length)
        },
        breadth: {
          unit: wAndD.dimensionUnit,
          value: parseInt(wAndD.width)
        },
        height: {
          unit: wAndD.dimensionUnit,
          value: parseInt(wAndD.height)
        }
      }
    }
    setselectProvider(false)
    try {
      const { data } = await axios({
        url: `${baseNodeapiUrl}/adapter/logistics/search`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: dataTosend
      })
      // console.log("search--->", data)
      if (data?.data) {
        const { transaction_id, message_id } = data.data.context
        setproviderPayload((prev) => {
          return { ...prev, transaction_id: transaction_id, message_id: message_id }
        })


      }
    } catch (err) {
      console.log("err----->", err);
      setselectProvider(null)
      toast.error("Please Try Again! Something Went Wrong", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  // async function getProviders() {
  //   const { data } = await axios({
  //     url: `https://prod-sellerapp.shiprocket.com/adapter/logistics/providers`,
  //     method: "POST",
  //     headers: {
  //       "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
  //     },
  //     data: providerPayload
  //   })

  //   setTimeout(() => {
  //     if (data.message == "flag1" && data?.data.length > 0) {
  //       setprovidersData(data.data)
  //       setselectProvider(true)
  //     } else {
  //       setselectProvider(null)
  //     }
  //   }, 3000);
  // }

  async function selectLogisticProvider(item, itemId) {

    setSubmitData(item);
    setIssChecked((prevItems) =>
      prevItems.map((item) =>
        item.id === itemId ? { ...item, checked: true } : { ...item, checked: false }
      )
    );

  }


  const [isSelectingProviders, setisSelectingProviders] = useState(false);
  const [isConfirmingProviders, setisConfirmingProviders] = useState(false);

  async function submitSelectedProvider() {
    setisSelectingProviders(true)
    const { transaction_id, message_id, bpp_id, bpp_uri, descripter, bpp_provider_id, item, location } = submitData
    const { data } = await axios({
      url: `${baseNodeapiUrl}/adapter/logistics/init`,
      method: "POST",
      headers: {
        "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
      },
      data: {
        "order_id": order_id,
        "transaction_id": transaction_id,
        "message_id": message_id,
        "bpp_id": bpp_id,
        "bpp_uri": bpp_uri,
        "descripter": descripter,
        "bpp_provider_id": bpp_provider_id,
        "category_id": item.category_id,
        "items_id": item.id,
        "descriptor": item.descriptor.code,
        "fulfillment_id": item.fulfillment_id,
        "location": location == null ? '' : location[0].id

        // "order_id": "2023-05-30-676472",
        // "transaction_id": "b1f11486-6a48-422b-aaf3-e6d98bfbffbf",
        // "message_id": "9569f153-9933-4046-a8f9-347b7fad9e20",
        // "bpp_id": "qaapis.delcaper.com",
        // "bpp_uri": "https://qaapis.delcaper.com/public/ondc",
        // "descripter": "Delcaper",
        // "descriptor": "P2P",
        // "bpp_provider_id": "Delcaper",
        // "category_id": "Same Day Delivery",
        // "items_id": "1",
        // "fulfillment_id": 1

      }
    })

    if (data?.data?.message?.ack?.status == "ACK") {
      setTimeout(() => {
        setprovidersModalOpen(false)
        setisSelectingProviders(false)
        console.log("timer function")
        hide("key#1")
        setisConfirmingProviders(true)
      }, 2000);
    } else {
      setisSelectingProviders(false)
      alert("Init Failed")

    }


  }


  const [isConfirmingProvider, setisConfirmingProvider] = useState(false)
  const [isUpdatingProvider, setisUpdatingProvider] = useState(false)
  const onConfirmHandler = async (cdata) => {
    try {
      setisConfirmingProvider(true)
      const { transaction_id, message_id, bpp_id, bpp_uri, descripter, bpp_provider_id, item, bpp_descriptor_name } = submitData

      const { data } = await axios({
        url: `${baseNodeapiUrl}/adapter/logistics/confirm`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {
          "transaction_id": transaction_id,
          "message_id": message_id,
          "bpp_id": bpp_id,
          "bpp_uri": bpp_uri,
          "order_id": order_id,
          "bpp_descriptor_name": bpp_descriptor_name
        }
      })

      if (data?.data?.message?.ack?.status == "ACK") {
        setisConfirmingProvider(false)
        toast.success("Provider Confirmed !", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // hide("key#2")
        getProvidersPayload()
      } else {
        setisConfirmingProvider(false)
        toast.error("Something went wrong !", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (err) {
      setisConfirmingProvider(false);
      toast.error("Something went wrong !", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log("error---->", err)
    }
  }
  const updateLSP = async (cdata) => {

    try {
      setisUpdatingProvider(true)
      const { transaction_id, message_id, bpp_id, bpp_uri, descripter, bpp_provider_id, item } = submitData

      const { data } = await axios({
        url: `${baseNodeapiUrl}/adapter/logistics/update`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {

          "transaction_id": transaction_id,
          "message_id": message_id,
          "bpp_id": bpp_id,
          "bpp_uri": bpp_uri,
          "order_id": order_id

          // "order_id": "2023-05-30-676472",
          // "transaction_id": "b1f11486-6a48-422b-aaf3-e6d98bfbffbf",
          // "message_id": "9569f153-9933-4046-a8f9-347b7fad9e20",
          // "bpp_id": "qaapis.delcaper.com",
          // "bpp_uri": "https://qaapis.delcaper.com/public/ondc",
          // "descripter": "Delcaper",
          // "descriptor": "P2P",
          // "bpp_provider_id": "Delcaper",
          // "category_id": "Same Day Delivery",
          // "items_id": "1",
          // "fulfillment_id": 1

        }
      })

      if (data?.data?.message?.ack?.status == "ACK") {
        setisUpdatingProvider(false)
        toast.success("Provider Confirmed !", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // hide("key#2")
      } else {
        setisUpdatingProvider(false)
        toast.error("Something went wrong !", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (err) {
      setisUpdatingProvider(false)
      console.log("error---->", err)
    }
  }



  const [shipmentStatusLoading, setshipmentStatusLoading] = useState(false)
  const [shipmentModalOpen, setshipmentModalOpen] = useState(false);
  const [providersModalOpen, setprovidersModalOpen] = useState(false)
  const Sstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 2,
  };
  const PSstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    p: 2,
  };

  const getShipmentStatus = async () => {
    setshipmentStatusLoading(true)
    setTimeout(() => {
      setshipmentModalOpen(true)
      setshipmentStatusLoading(false)
      // statusModal()
    }, 2000);

    try {
      const { data } = await axios({
        method: "POST",
        url: `${baseNodeapiUrl}/adapter/logistics/status`,
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {
          "buyer_order_id": "2023-07-31-509804"
        }
      })
      // console.log("data----->", data)
    } catch (err) {
      console.log("some error--->", err)
    }


  }

  function handleShipementModalClose() {
    setshipmentModalOpen(false)
  }

  // ---------------------------------- Code functions for logistics End------------------------------------------------



  // ----------------------------------------Code functions for Download invoice start-----------------------------------------
  function PDFGenerator() {
    const element = document.getElementById('page-content'); // ID of the element containing the page content
    html2pdf().set({ margin: 0, filename: `Invoice - ${order_id}`, image: { type: 'jpeg', quality: 1.0 } }).from(element).save();
  }

  async function sendStatusHandler() {

    try {
      setsendingOrderStatus(true)
      const { data } = await axios({
        url: `${baseNodeapiUrl}/shiprocket/unsolicated_status`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {
          "order_id": order_id
        }

      })

      if (data?.message?.ack?.status === "ACK") {
        toast.success("Unsolicated Status Updated")
        setsendingOrderStatus(false)
      } else {
        setsendingOrderStatus(false)
        toast.error("Error in Update!!")
      }
    } catch (err) {
      setsendingOrderStatus(false)
      console.log("Something Went Wrong!!", err)
    }
    setsendingOrderStatus(false)
    console.log(data)
  }


  // ----------------------------------------Code functions for Download invoice end-----------------------------------------


  const Alert = React.forwardRef(function Alert(
    props,
    ref,
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const [invoiceHolder, setInvoiceHolder] = useState({ origin: "manual", path: "" })
  const PdfHandler = async (e) => {

    try {
      const files = e.target.files;

      const uploadPromises = Array.from(files).map(async (file) => {
        const formData = new FormData();
        formData.append("file", file);

        const { data } = await axios({
          url: `${uploadUrl}/upload`,
          method: "POST",
          headers: {
            "X-Custom-Authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`
          },
          data: formData
        });

        return data?.urls?.[0];
      });

      const locations = await Promise.all(uploadPromises);
      let invoiceUrl = locations[0]
      setInvoiceHolder({ path: invoiceUrl, origin: "manual" })

    } catch (exception) {
      toast.error("Error in Adding Product Image");
      console.log(exception);
    }
  };

  async function saveInvoice() {
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/addInvoiceurl`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {
          order_id,
          invoice: invoiceHolder.path
        }
      })

      if (data.status == 200) {
        toast.success("Invoice Saved!");
        setInvoiceHolder({
          path: invoiceHolder.path,
          origin: "database"
        })
      } else {
        toast.error("Something went wrong, please try later!")
      }
    } catch (err) {
      toast.error("Server error, please try later!")
    }
  }

  const [products, setProducts] = useState([]);
  const [imeiErrors, setImeiErrors] = useState({});

  const handleImeiChange = (productId, value) => {
    const normalizedValue = value.replace(/\D/g, "").slice(0, 15);
    setProducts((prev) =>
      prev.map((item) =>
        item.product_id === productId
          ? { ...item, imei_number: normalizedValue }
          : item
      )
    );

    setImeiErrors((prev) => {
      if (!(productId in prev)) return prev;
      return {
        ...prev,
        [productId]: normalizedValue.length === 15
          ? ""
          : "IMEI must be exactly 15 digits.",
      };
    });
  };

  const [submittingImeiId, setSubmittingImeiId] = useState(null);
  const baseUrl = config.apiUrl;

  const submitIMEI = async () => {
    const itemsToSubmit = products?.filter(
      (p) => p.product_name !== "Delivery charges"
    );

    const nextImeiErrors = {};
    itemsToSubmit.forEach((item) => {
      const imei = item.imei_number || "";
      if (!/^\d{15}$/.test(imei)) {
        nextImeiErrors[item.product_id] = imei
          ? "IMEI must be exactly 15 digits."
          : "Please enter the 15-digit IMEI.";
      }
    });

    setImeiErrors(nextImeiErrors);
    if (Object.keys(nextImeiErrors).length > 0) {
      toast.error("Enter a valid 15-digit IMEI for each product.");
      return;
    }

    setSubmittingImeiId("all");
    try {
      const payload = {
        order_id: order_id,
        items: itemsToSubmit.map((p) => ({
          item_id: p.product_id,
          imei: p.imei_number,
        })),
      };

      const response = await axios.post(`${baseUrl}/imei_update`, payload, {
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
      });

      const data = response?.data;
      if (data?.success) {
        toast.success(data?.message);
        setProducts((prev) =>
          prev.map((item) =>
            item.product_name !== "Delivery charges"
              ? { ...item, imei_submitted: true }
              : item
          )
        );
      } else {
        toast.error(data?.data?.error?.message || data?.message || "IMEI update failed");
      }
    } catch (error) {
      toast.error("Something went wrong");
      console.log(error);
    } finally {
      setSubmittingImeiId(null);
    }
  };

  useEffect(() => {
    if (
      _orderDetail?.transaction_id &&
      _orderDetail?.shipping_address?.length > 0 &&
      orderDetail?.length > 0
    ) {
      searchApi();
    }
  }, [_orderDetail?.transaction_id,]);

  const [searchData, setSearchData] = useState({});
  const [searchLoading, setSearchLoading] = useState(false);
  const searchApi = async () => {
    setSearchLoading(true);
    try {
      const response = await axios({
        method: 'POST',
        url: `${baseNodeapiUrl}/pro-route/v1/search`,
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {
          //
          "context": {
            "transaction_id": _orderDetail?.transaction_id,
            estimate_id: searchData?.data?.estimate_id || ""
          },
          //
          "message": {
            "delivery_type": "Immediate Delivery",
            //
            "opening_days": "1,2,3,4",
            "holidays": [
              "2023-06-29",
              "2023-08-15"
            ],
            "rts_tat": "PT30S",
            "shop_open_time": "1100",
            "shop_close_time": "2100",
            "fulfillment_type": "Delivery",
            //
            "pickup_details": {
              "gps": _orderDetail.shipping_address[0].start.location.gps,//"12.453544,77.928379",
              "area_code": _orderDetail.shipping_address[0].start.location.address.area_code,//"201301",
              // "authentication_type": "OTP"
            },
            "delivery_details": {
              "gps": _orderDetail.shipping_address[0].end.location.gps,//"12.453544,77.928379",
              "area_code": _orderDetail.shipping_address[0].end.location.address.area_code,//"20301",
              // "authentication_type": "OTP"
            },
            "payment_details": {
              "type": "ON-ORDER",
              "collection_amount": "0"
            },
            "packing_details": {
              "weight": {
                "unit": "kilogram",
                "value": orderDetail[0].weight || "1",
              },
              //
              "length": {
                "unit": "centimeter",
                "value": 1
              },
              "breadth": {
                "unit": "centimeter",
                "value": 1
              },
              "height": {
                "unit": "centimeter",
                "value": 1
              },
              //
              "price": {
                "unit": "INR",
                "value": JSON.parse(_orderDetail.quote).price.value || "100"
              },
              "category": "Grocery",
              "dangerous_goods": false
            }
          }
        }

      })
      setSearchData(response?.data);
      console.log("response ---->", response?.data?.id);
      setSearchLoading(false);
    } catch (error) {
      setSearchLoading(false);
      console.log("Error ------>", error);
    }
  }

  const [confirmData, setConfirmData] = useState({});
  const confirmHandler = async () => {
    setSearchLoading(true);
    try {
      const response = await axios({
        method: 'POST',
        url: `${baseNodeapiUrl}/pro-route/v1/confirm`,
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
        },
        data: {
          "context": {
            "transaction_id": _orderDetail?.transaction_id
          },
        }
      })
      setConfirmData(response?.data);
      console.log("response ---->", response);
      setSearchLoading(false);
      getLogisticOrderClient()
    } catch (error) {
      setSearchLoading(false);
      console.log("Error ------>", error);
    }
  }

  /* ---------------- derived, presentation-only values (no new API calls / no new state) ---------------- */
  const nonDeliveryProducts = products?.filter((p) => p.product_name !== "Delivery charges") || [];
  const imeiSubmittedCount = nonDeliveryProducts.filter((p) => p.imei_submitted).length;
  const isCancelledOrder = orderState?.order_state === "Cancelled";
  const isCompletedOrder = orderState?.order_state === "Completed";
  const shippedDone = ["Order-picked-up", "Out-for-delivery", "Order-delivered"].includes(orderState?.fulfillment_state);
  const deliveredDone = orderState?.fulfillment_state === "Order-delivered" || isCompletedOrder;

  const stepDefs = [
    {
      key: "placed",
      label: "Order placed",
      sub: _orderDetail?.created_at ? moment.utc(_orderDetail.created_at).format("DD MMM, HH:mm") : "—",
      done: true,
      active: false,
    },
    {
      key: "imei",
      label: "IMEI verification",
      sub: `${imeiSubmittedCount} of ${nonDeliveryProducts.length || 0} submitted`,
      done: imeiSubmitted,
      active: !imeiSubmitted,
    },
    {
      key: "progress",
      label: isCancelledOrder ? "Cancelled" : (orderState?.order_state || "In progress"),
      sub: isCancelledOrder ? "Order cancelled" : "Current stage",
      done: imeiSubmitted && (isCompletedOrder || isCancelledOrder),
      active: imeiSubmitted && !isCompletedOrder && !isCancelledOrder,
    },
    {
      key: "shipped",
      label: "Shipped",
      sub: orderState?.tracking_url ? "Tracking available" : "Awaiting tracking",
      done: shippedDone,
      active: false,
    },
    {
      key: "delivered",
      label: "Delivered",
      sub: deliveredDone ? "Completed" : "—",
      done: deliveredDone,
      active: false,
    },
  ];

  const grandTotalValue = _orderDetail?.return_amount ? _orderDetail?.return_amt : _orderDetail?.total_price;
  const deliveryChargeValue = logisticCharges?.breakup?.length === 3
    ? logisticCharges?.breakup[logisticCharges?.breakup.length - 2]?.price?.value
    : logisticCharges?.breakup?.length === 2
      ? logisticCharges?.breakup[logisticCharges?.breakup.length - 1]?.price?.value
      : undefined;

  return (
    <>
      <ThemeMaker>
        {!isLoading ? (
          <div style={S.page}>
            <div style={S.grid}>
              {/* ===================== MAIN COLUMN ===================== */}
              <div style={S.mainCol}>

                {/* Order header */}
                <div style={S.card}>
                  <div style={S.headerRow}>
                    <div>
                      <div style={S.eyebrow}>Order</div>
                      <div style={S.orderTitle}>Order ID <span style={{ color: palette.subtext, fontWeight: 500 }}>·</span> <span style={S.orderIdMono}>{order_id}</span></div>
                    </div>
                    {showdat ? (
                      <div style={S.otpBadge}>
                        <span style={S.otpDot} /> OTP&nbsp;{showdat}
                      </div>
                    ) : null}
                  </div>
                </div>

                {/* Stepper */}
                <div style={S.card}>
                  <div style={{ display: "flex", width: "100%" }}>
                    {stepDefs.map((step, i) => {
                      const state = step.done ? "done" : step.active ? "active" : "pending";
                      return (
                        <React.Fragment key={step.key}>
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: "70px" }}>
                            <div style={S.stepDot(state)}>{step.done ? "✓" : state === "active" ? "●" : ""}</div>
                            <div style={{ ...S.stepLabel, textAlign: "center" }}>{step.label}</div>
                            <div style={{ ...S.stepSub, textAlign: "center" }}>{step.sub}</div>
                          </div>
                          {i < stepDefs.length - 1 && <div style={S.stepLine(step.done)} />}
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>

                {/* Item details */}
                <div style={S.card}>
                  <SectionTitle>Item details</SectionTitle>

                  {orderDetail &&
                    orderDetail.map((item, index) => {
                      const currentProduct = products?.find((p) => p.product_id === item.product_id);
                      const isSubmitted = currentProduct?.imei_submitted;
                      return (
                        <div style={S.itemRow} key={index}>
                          <div style={S.itemImgWrap}>
                            <img src={item?.image?.split(",")[0]} alt="image" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ color: palette.text, fontSize: "15px", marginBottom: "4px" }}>{item?.product_name}</div>
                            <div style={S.itemMeta}>
                              {item?.category_name ? <span>Category: <b>{item?.category_name}</b></span> : null}
                              {item?.weight ? <span>Size <b>{item?.weight}</b></span> : null}
                              {item?.quantity ? <span>Qty <b>{item?.quantity}</b></span> : null}
                              {item?.price ? <span>Price <b>₹{item?.price}</b></span> : null}
                            </div>
                            {item?.cancel_qty ? <div style={{ ...S.itemMeta, marginTop: "4px", color: palette.red }}>Cancel Qty: {item?.cancel_qty}</div> : null}
                            {alldetails?.reason_codes ? (
                              <div style={{ ...S.itemMeta, marginTop: "4px" }}>
                                Cancellation Reason: {cancelReasonStatement?.filter(r => r?.code == alldetails?.reason_codes)?.map((r, ri) => <span key={ri}>{r?.text}</span>)}
                              </div>
                            ) : null}

                            {item?.product_name !== "Delivery charges" && (
                              <div style={{ marginTop: "10px" }}>
                                <label style={S.fieldLabel}>IMEI number</label>
                                {isSubmitted ? (
                                  <div style={{ fontSize: "14px", color: palette.text }}>{currentProduct?.imei_number}</div>
                                ) : (
                                  <div style={S.imeiWrap}>
                                    <input
                                      type="text"
                                      placeholder="Enter IMEI number"
                                      value={currentProduct?.imei_number || ""}
                                      maxLength={15}
                                      inputMode="numeric"
                                      aria-invalid={!!imeiErrors[item.product_id]}
                                      onChange={(e) =>
                                        handleImeiChange(
                                          item.product_id,
                                          e.target.value
                                        )
                                      }
                                      style={{ ...S.input, maxWidth: "320px", borderColor: imeiErrors[item.product_id] ? palette.red : palette.border }}
                                    />
                                    <span style={S.imeiCheckBtn}>✓</span>
                                  </div>
                                )}
                                {imeiErrors[item.product_id] && !isSubmitted && (
                                  <div role="alert" style={{ color: palette.red, fontSize: "12px", marginTop: "5px" }}>
                                    {imeiErrors[item.product_id]}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}

                  {!imeiSubmitted && (
                    <div style={S.noteBar}>
                      <span>ⓘ</span>
                      <span><b>Note:</b> Submit IMEI before updating Order Status and Fulfillment Status.</span>
                    </div>
                  )}


                  {!imeiSubmitted && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",

                        marginTop: "16px",
                      }}
                    >
                      <button style={{ ...S.primaryBtn, opacity: submittingImeiId === "all" ? 0.65 : 1 }} onClick={submitIMEI} disabled={submittingImeiId === "all"}>
                        {submittingImeiId === "all" ? "Submitting..." : "Submit IMEI"}
                      </button>
                    </div>
                  )}
                </div>

                {/* Status & fulfillment */}
                {orderState?.order_state !== "Cancelled" ? (
                  <div style={S.card}>
                    <SectionTitle>Fulfillment status</SectionTitle>

                    <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "18px" }}>
                      {orderedFulfillments.length === 0 ? (
                        <div style={{ fontSize: "13px", color: palette.subtext }}>Loading fulfillment steps…</div>
                      ) : (
                        orderedFulfillments.map((step, i) => {
                          const done = i <= currentFulfillmentIndex;
                          const isNext = i === currentFulfillmentIndex + 1;
                          return (
                            <div key={step.id} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <span style={S.stepDot(done ? "done" : isNext ? "active" : "todo")}>
                                {done ? "✓" : i + 1}
                              </span>
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: isNext ? 700 : 600,
                                  color: done ? palette.text : isNext ? palette.indigo : palette.subtext,
                                }}
                              >
                                {stepDisplayName(step)}
                              </span>
                            </div>
                          );
                        })
                      )}
                    </div>

                    {showPop ? (
                      <>
                        <div
                          onClick={() => setShowPop(false)}
                          className={`cancelpopupoverlay`}
                        ></div>
                        <div className={`popup `}>
                          <p className="text-right p-2"> <CloseIcon role="button" onClick={() => setShowPop(false)} className="text-dark" />
                          </p>
                          <p className="text-center p-2" style={{ fontSize: "20px", fontWeight: "800", color: "black" }}>Partial Cancellation</p>

                          {orderDetail &&
                            orderDetail.map((item, index) => {
                              return (

                                <>
                                  <div className="row p-4 mb-2" key={index}>
                                    <div className="d-flex PMOrdeList" style={{ gap: "2px" }}>


                                      <div style={{ width: "200px", height: "200px" }}>
                                        <img src={item?.image} alt="" style={{ width: "100%", height: "100%" }} />
                                      </div>

                                      <div>
                                        <div className="col-12 mb-2">
                                          <span className="allkeys">Product Name:</span>  {item.product_name}
                                        </div>
                                        <div className="col-md-12 ">
                                          <span className="allkeys">Order Quantity:</span>   {item.quantity}
                                        </div>

                                        {(item.quantity == item?.cancel_qty) ? <div className="mt-2"> <span className="badge badge-danger">Product Cancelled</span> </div> : <>
                                          <div className="col-md-12">
                                            <label className="col-form-label allkeys" >
                                              Cancel Quantity:
                                            </label>
                                            <input
                                              type="number"
                                              style={{
                                                border: "none",
                                                borderBottom: "1px solid #ccc",
                                              }}
                                              name="qty"
                                              min={1}
                                              max={item.quantity}
                                              value={item.qty}
                                              onChange={(e) => {
                                                if (item.cancel_qty === "") {
                                                  if ((parseInt(e.target.value) < 1)) {
                                                    setshowGreaterValueAlert(true);
                                                    setTimeout(() => setshowGreaterValueAlert(false), 3000)
                                                    e.target.value = ""
                                                  } else {
                                                    setcancelQuantityl(e.target.value)
                                                  }

                                                } else {
                                                  if ((parseInt(e.target.value) > (parseInt(item.quantity)) - parseInt(item.cancel_qty)) || (parseInt(e.target.value) < 1)) {
                                                    setshowGreaterValueAlert(true);
                                                    setTimeout(() => setshowGreaterValueAlert(false), 3000)
                                                    setcancelQuantityl("");
                                                    e.target.value = ""
                                                  } else {
                                                    setcancelQuantityl(e.target.value)
                                                  }
                                                }


                                              }}
                                            />
                                          </div>
                                          <div className="col-md-12">
                                            {item?.cancel_qty && (
                                              <span className="allkeys" style={{ color: "red" }}>Cancelled Qty : {item?.cancel_qty}</span>
                                            )}
                                          </div>
                                          <div className="col-md-12" >
                                            <div>
                                              <label className="col-form-label allkeys">
                                                Cancel Reason:
                                              </label>
                                              <select className="col-md-6 text-left" name="reason" value={item.reason}

                                                onChange={(e) => {
                                                  setreasonCode(e.target.value)
                                                }}
                                              >
                                                <option value="001">
                                                  Select Cancle Reason
                                                </option>
                                                {
                                                  cancelReasonStatement.filter(item => item?.show == true).map((item, index) => (
                                                    <option value={item.code} key={index}>{item.text}</option>
                                                  ))
                                                }
                                              </select>

                                            </div>
                                          </div>
                                          <div className="mt-2">
                                            <div className="col-6 justify-content-end position-relative p-2">
                                              <button
                                                className="btn btn-primary align-end"
                                                type="submit"
                                                onClick={(e) => cancelPartial(e, item)}
                                              >
                                                {
                                                  cancellingProduct == item.id ? "Cancelling..." : "Cancel"
                                                }

                                              </button>
                                            </div>
                                          </div>
                                        </>}

                                      </div>
                                    </div>
                                  </div >
                                  <hr className="hr" />
                                </>

                              );
                            })}

                          <div className="col-12 d-flex justify-content-end position-relative p-2">
                            <button
                              className="btn btn-primary align-end"
                              onClick={(e) => setShowPop(false)}
                            >
                              Done
                            </button>
                          </div>
                        </div>
                      </>
                    ) : null}

                    {order?.update ? (
                      <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", flexWrap: "wrap", gap: "10px" }}>
                        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                          {nextFulfillmentStep ? (
                            <button
                              style={S.primaryBtn}
                              disabled={updatingFulfillment || !imeiSubmitted}
                              onClick={advanceFulfillment}
                            >
                              {updatingFulfillment ? "Updating..." : `Mark as ${stepDisplayName(nextFulfillmentStep)}`}
                            </button>
                          ) : (
                            <button style={{ ...S.primaryBtn, opacity: 0.6, cursor: "default" }} disabled>
                              Fulfillment complete
                            </button>
                          )}
                          {!imeiSubmitted && (
                            <span style={{ alignSelf: "center", fontSize: "12px", color: palette.subtext }}>
                              Submit IMEI to unlock
                            </span>
                          )}
                        </div>

                        <div style={{ position: "relative" }}>
                          {/* <button onClick={cancelbtn} style={S.dangerOutlineBtn}>Cancel order</button> */}

                          {cancelpopup ? (
                            <>
                              <div onClick={() => setcancelpopup(false)}
                                className={`cancelpopupoverlay`}></div>
                              <div className={`cancelorderpopup p-3 `}>
                                <div className="row">
                                  <div className="col-12 ">
                                    <select className="btn btn-outline-dark w-100 text-left"
                                      value={cancelreson} onChange={(e) =>
                                        changeReturnStatus(e.target.value)
                                      }>
                                      <option value="">
                                        Select Cancel Reason
                                      </option>
                                      <option value="002">
                                        One or more items in the Order not available
                                      </option>
                                      <option value="005">
                                        Merchant rejected the order
                                      </option>
                                      <option value="011">
                                        Buyer not found or cannot be contacted
                                      </option>
                                      <option value="012">
                                        Buyer does not want product any more
                                      </option>
                                      <option value="013">
                                        Buyer refused to accept delivery
                                      </option>
                                      <option value="014">Address not found</option>
                                      <option value="015">
                                        Buyer not available at location
                                      </option>
                                      <option value="018">
                                        Delivery pin code not serviceable
                                      </option>
                                      <option value="019">
                                        Pickup pin code not serviceable
                                      </option>
                                      <option value="020">
                                        Order lost in transit
                                      </option>
                                    </select>
                                    <p className="text-center mt-3 d-none">{`You selected : ${cancelreson}`}</p>
                                  </div>
                                  <div className="col-12 m-2 p-2 d-flex justify-content-between">
                                    <button
                                      className="btn btn-outline-dark col-5 col-md-5"
                                      onClick={() => setcancelpopup(false)}
                                    >
                                      Close
                                    </button>
                                    <button
                                      className="btn btn-outline-danger col-5 col-md-5"
                                      onClick={() => ordercancel()}
                                    >
                                      Cancel Order
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <div style={S.card}>
                    <span className="badge badge-danger" style={{ display: "inline-block", marginBottom: "12px" }}>Order Cancelled</span>
                    <br />
                    {/* <button style={S.secondaryBtn} onClick={sendStatusHandler} disabled={sendingOrderStatus}>
                      {sendingOrderStatus ? "Sending Staus..." : "Send order status"}
                    </button> */}
                  </div>
                )}

                {/* Logistics — On Network */}
                {networkLogistics && (
                <div style={S.card}>

                  <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span
                        style={{
                          width: "4px",
                          height: "18px",
                          backgroundColor: "#0F9D8A",
                          borderRadius: "4px",
                          display: "inline-block",
                        }}
                      ></span>

                      <span
                        style={{
                          color: palette.teal,
                          fontWeight: 700,
                          fontSize: "15px",
                        }}
                      >
                        Logistics — On Network
                      </span>
                    </div>
                    {/* <span style={S.toggleTrack(true)}> */}
                    {/* <span style={S.toggleThumb(false)} />
                      <input type="radio" checked name="logistics" readOnly style={{ display: "none" }} />
                    </span> */}
                    {/* <span style={{ fontSize: "13px", color: palette.subtext }}>Off network</span> */}
                  </div>

                  {/* <div style={{ background: "#f6f7fb", border: `1px solid ${palette.border}`, borderRadius: "8px", padding: "18px" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "12px" }}>
                      <div style={{ fontSize: "13px", color: palette.subtext, maxWidth: "460px" }}>
                        Get a live courier quote for this order based on pincode {_orderDetail?.billing_address?.address?.area_code} and package weight.
                      </div>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <button style={S.primaryBtn} onClick={searchApi} disabled={searchLoading}>
                          {searchLoading ? "Please wait..." : "Get logistics quote"}
                        </button>
                        {searchData?.id && (
                          <button onClick={confirmHandler} style={{ ...S.primaryBtn, background: palette.green }} disabled={searchLoading}>
                            {searchLoading ? "please wait..." : "Confirm"}
                          </button>
                        )}
                      </div>
                    </div>
                    

                    {searchData?.id && (
                      <div style={{ display: "flex", gap: "24px", marginTop: "16px", background: "#fff", border: `1px solid ${palette.border}`, borderRadius: "5px", padding: "12px 16px", width: "fit-content" }}>
                        <div>
                          <div style={{ fontSize: "11px", color: palette.subtext, fontWeight: 700 }}>QUOTE ID</div>
                          <div style={{ fontSize: "14px", fontWeight: 600 }}>{searchData?.id}</div>
                        </div>
                        <div>
                          <div style={{ fontSize: "11px", color: palette.subtext, fontWeight: 700 }}>PRICE</div>
                          <div style={{ fontSize: "14px", fontWeight: 700, color: palette.green }}>₹{searchData?.price?.value}</div>
                        </div>
                      </div>
                    )}

                    {confirmData?.order?.id && (
                      <div style={{ marginTop: "16px", paddingTop: "16px", borderTop: `1px solid ${palette.border}`, display: "flex", gap: "24px", flexWrap: "wrap" }}>
                        <div>
                          <div style={{ fontSize: "11px", color: palette.subtext, fontWeight: 700 }}>ORDER ID</div>
                          <div style={{ fontSize: "14px", fontWeight: 700 }}>{confirmData?.order?.id}</div>
                        </div>
                        <div>
                          <div style={{ fontSize: "11px", color: palette.subtext, fontWeight: 700 }}>CLIENT ORDER ID</div>
                          <div style={{ fontSize: "14px", fontWeight: 700 }}>{confirmData?.order?.client_order_id}</div>
                        </div>
                        <div>
                          <div style={{ fontSize: "11px", color: palette.subtext, fontWeight: 700 }}>STATUS</div>
                          <span className="badge bg-warning text-dark">{confirmData?.order?.state}</span>
                        </div>
                      </div>
                    )}
                  </div> */}
                  {logisticData?.every(item => (item?.logistics?.state ?? item?.state) !== "UnFulfilled") ? <>{searchLoading ? (
                    <p>Loading...</p>
                  ) : searchData?.data ? (
                    <div>
                      {/* <p>
                        Your order is estimated to be delivered in{" "}
                        <span
                          style={{
                            fontWeight: 700,
                            color: "#000",
                          }}
                        >
                          {searchData.data.estimated_delivery_time} minutes
                        </span>{" "}
                        with a delivery charge of{" "}
                        <span
                          style={{
                            fontWeight: 700,
                            color: "#000",
                          }}
                        >
                          ₹{searchData.data.price}
                        </span>
                        .
                      </p> */}

                      {/* <div className="btn  d-flex justify-content-end mt-4">
                        <button onClick={confirmHandler}
                          className="btn-primary"
                          style={S.primaryBtn}


                        >
                          Confirm
                        </button>
                      </div> */}

                    </div>
                  ) : (
                    <p>No data found</p>
                  )}</> : null}


                  <div style={{ overflow: "scroll" }}>
                    {logisticData.length > 0 ? <table
                      className="table mb-0"
                      style={{
                        borderCollapse: "separate",
                        borderSpacing: "0",
                        width: "1000px"
                      }}
                    >
                      <thead style={{ background: "#f7f8fc" }}>
                        <tr>
                          <th
                            style={{
                              padding: "18px",
                              color: "#4E6484",
                              fontWeight: "600",
                              border: "none",
                            }}
                          >
                            Order ID
                          </th>

                          <th
                            style={{
                              padding: "18px",
                              color: "#4E6484",
                              fontWeight: "600",
                              border: "none",
                            }}
                          >
                            Price
                          </th>

                          <th
                            style={{
                              padding: "18px",
                              color: "#4E6484",
                              fontWeight: "600",
                              border: "none",
                            }}
                          >
                            State
                          </th>

                          <th
                            style={{
                              padding: "18px",
                              color: "#4E6484",
                              fontWeight: "600",
                              border: "none",
                            }}
                          >
                            LSP Name
                          </th>

                          <th
                            style={{
                              padding: "18px",
                              color: "#4E6484",
                              fontWeight: "600",
                              border: "none",
                            }}
                          >
                            Estimated Pickup Time
                          </th>

                          <th
                            style={{
                              padding: "18px",
                              color: "#4E6484",
                              fontWeight: "600",
                              border: "none",
                            }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {logisticData?.length > 0 ? (
                          logisticData?.map((item, index) => {
                            const l = item?.logistics || {};
                            const state = l.state || item?.order_state || "-";
                            const pill = logisticStatePill(state);
                            const cancelled = isLogisticCancelled(item);
                            const price = l?.fees?.total_with_tax ?? l?.price;
                            const cancelReasonDesc = l?.cancellation?.reason_desc;
                            return (
                            <tr
                              key={l.id ?? item.id ?? index}
                              style={{
                                borderTop: "1px solid #ECECEC",
                              }}
                            >
                              <td
                                style={{
                                  padding: "18px",
                                  verticalAlign: "middle",
                                  fontWeight: "500",
                                  color: "#4C3FE0",
                                }}
                              >
                                {l.order_id || item?.order_id || "-"}
                              </td>

                              <td
                                style={{
                                  padding: "18px",
                                  verticalAlign: "middle",
                                  fontWeight: "500",
                                }}
                              >
                                {price !== undefined && price !== null && price !== "" ? `₹${price}` : "-"}
                              </td>

                              <td
                                style={{
                                  padding: "18px",
                                  verticalAlign: "middle",
                                }}
                              >
                                <span
                                  style={{
                                    background: pill.bg,
                                    color: pill.fg,
                                    padding: "8px 18px",
                                    borderRadius: "30px",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    display: "inline-block",
                                    minWidth: "120px",
                                    textAlign: "center",
                                  }}
                                >
                                  {state}
                                </span>
                                {cancelled && cancelReasonDesc ? (
                                  <div style={{ fontSize: "12px", color: pill.fg, marginTop: "6px", maxWidth: "220px" }}>
                                    {cancelReasonDesc}
                                  </div>
                                ) : null}
                              </td>

                              <td
                                style={{
                                  padding: "18px",
                                  verticalAlign: "middle",
                                  fontWeight: "500",
                                }}
                              >
                                {l.lsp?.name || "-"}
                              </td>

                              <td
                                style={{
                                  padding: "18px",

                                  verticalAlign: "middle",
                                  fontWeight: "500",
                                }}
                              >
                                {l.estimated_pickup_time
                                  ? moment.utc(l.estimated_pickup_time).format("DD MMM YYYY, hh:mm A")
                                  : "-"}
                              </td>

                              <td
                                style={{
                                  padding: "18px",
                                  verticalAlign: "middle",
                                }}
                              >
                                <button
                                  className="btn btn-sm me-2"
                                  style={{
                                    background: "#EEF3FF",
                                    color: "#4C3FE0",
                                    border: "none",
                                    borderRadius: "8px",

                                    width: "36px",
                                    height: "36px",
                                  }}
                                  onClick={() => {
                                    setSelectedLogisticRow(item);
                                    setShowLogisticEyeModal(true);
                                  }}
                                >
                                  <FaEye />
                                </button>
                                {!cancelled && (
                                  <button
                                    className="btn btn-sm"
                                    style={{
                                      background: "#FFF4E5",
                                      color: "#F59E0B",
                                      border: "none",
                                      borderRadius: "8px",
                                      marginLeft: "5px",
                                      width: "36px",
                                      height: "36px",
                                    }}
                                    onClick={() => {
                                      setSelectedLogisticRow(item);
                                      setSelectedLogisticType("");
                                      setShowLogisticEditModal(true);
                                    }}
                                  >
                                    <FaEdit />
                                  </button>
                                )}
                              </td>
                            </tr>
                            );
                          })
                        ) : null}
                      </tbody>
                    </table> : null}
                  </div>



                  <>
                    <Modal
                      open={showLogisticEditModal}
                      onClose={() => setShowLogisticEditModal(false)}
                    >
                      <Box
                        sx={{
                          ...Sstyle,
                          width: 430,
                          bgcolor: "#fff",
                          borderRadius: "14px",
                          border: "none",
                          boxShadow: "0 10px 35px rgba(0,0,0,0.15)",
                          p: 3,
                        }}
                      >
                        <div
                          className="d-flex w-100 justify-content-between align-items-start mb-2"
                        >
                          <div>
                            <div style={{ fontSize: "15px", fontWeight: 700, color: palette.text }}>Cancel Logistic Order</div>
                            <div style={{ fontSize: "12px", color: palette.subtext, fontFamily: "monospace", marginTop: "2px" }}>
                              {selectedLogisticRow?.logistics?.order_id || selectedLogisticRow?.order_id || ""}
                            </div>
                          </div>
                          <span
                            style={{
                              cursor: "pointer",
                              background: "#F5F5F5",
                              borderRadius: "50%",
                              width: "34px",
                              height: "34px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            onClick={() => setShowLogisticEditModal(false)}
                          >
                            <CloseIcon fontSize="small" />
                          </span>
                        </div>



                        <select
                          className="form-select  w-100  mb-3 mt-4"

                          value={selectedLogisticType}
                          onChange={(e) => setSelectedLogisticType(e.target.value)}
                          style={{
                            height: "50px",
                            borderRadius: "10px",
                            border: "1px solid #D9D9D9",
                            fontSize: "14px",
                            boxShadow: "none",
                          }}
                        >
                          <option value="">Select Option</option>
                          <option value="002">One or more items in the Order not available</option>
                          <option value="005">Merchant rejected the order</option>
                          <option value="006">Order not shipped as per buyer app SLA</option>
                          <option value="008">Order / fulfillment not ready for pickup</option>
                          <option value="010">Buyer wants to modify details</option>
                          <option value="011">Buyer not found or cannot be contacted</option>
                          <option value="012">Buyer does not want product any more</option>
                          <option value="013">Buyer refused to accept delivery</option>
                          <option value="014">Address not found</option>
                          <option value="015">Buyer not available at location</option>
                          <option value="016">Accident / rain / strike / vehicle issues</option>
                          <option value="017">Order delivery delayed or not possible</option>
                          <option value="018">Delivery delayed or not possible</option>
                          <option value="020">Lost in transit</option>
                        </select>

                        <div className="d-flex justify-content-end mt-2">
                          <div className="d-flex justify-content-end">
                            <button
                              type="button"
                              className="btn"
                              onClick={handleCancelOrder}
                              disabled={isCancelling}
                              style={{
                                backgroundColor: "#DC3545",
                                color: "#fff",
                                border: "none",
                                borderRadius: "10px",
                                padding: "10px 28px",
                                fontSize: "15px",
                                fontWeight: "600",
                                opacity: isCancelling ? 0.7 : 1,
                                cursor: isCancelling ? "not-allowed" : "pointer",
                              }}
                            >
                              {isCancelling ? "Cancelling..." : "Cancel"}
                            </button>
                          </div>
                        </div>
                      </Box>
                    </Modal>

                    <Modal
                      open={showLogisticEyeModal}
                      onClose={() => setShowLogisticEyeModal(false)}
                    >
                      <Box
                        sx={{
                          ...Sstyle,
                          width: 460,
                          maxWidth: "92%",
                          bgcolor: "#fff",
                          borderRadius: "16px",
                          border: "1px solid #EDEDED",
                          boxShadow: "0 10px 35px rgba(0,0,0,0.15)",
                          p: 0,
                          overflow: "hidden",
                        }}
                      >
                        {(() => {
                          const row = selectedLogisticRow || {};
                          const lg = row.logistics || {};
                          const state = lg.state || row.order_state || "-";
                          const pill = logisticStatePill(state);
                          const fulfillment = (Array.isArray(row.fulfillments) ? row.fulfillments[0] : row.fulfillments) || {};
                          const pickup = fulfillment.start || {};
                          const dropoff = fulfillment.end || {};
                          const pickupName =
                            pickup?.location?.descriptor?.name || pickup?.person?.name || "-";
                          const pickupAddr =
                            formatOndcAddress(pickup?.location?.address) || pickup?.location?.gps || "";
                          const pickupPhone = pickup?.contact?.phone || "";
                          const dropName =
                            dropoff?.person?.name ||
                            dropoff?.location?.address?.name ||
                            row?.name ||
                            row?.billing?.name ||
                            "-";
                          const dropAddr =
                            formatOndcAddress(dropoff?.location?.address) ||
                            formatOndcAddress(row?.billing?.address) ||
                            dropoff?.location?.gps ||
                            "";
                          const dropPhone =
                            dropoff?.contact?.phone ||
                            row?.contact_number ||
                            row?.billing?.phone ||
                            "";
                          const cancellation = lg.cancellation || {};
                          return (
                            <>
                              {/* Header */}
                              <div style={{ padding: "20px 20px 16px", borderBottom: "1px solid #EDEDED" }}>
                                <div className="d-flex w-100 justify-content-between align-items-start">
                                  <div>
                                    <p style={{ fontSize: "12px", color: "#9A9A9A", margin: "0 0 4px", fontFamily: "monospace" }}>
                                      {lg.order_id || row.order_id || "-"}
                                    </p>
                                    <p style={{ fontSize: "18px", color: "black", margin: 0, fontWeight: 600 }}>
                                      Logistic Order
                                    </p>
                                  </div>
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      background: "#F5F5F5",
                                      borderRadius: "50%",
                                      width: "28px",
                                      height: "28px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                    onClick={() => setShowLogisticEyeModal(false)}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </span>
                                </div>

                                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "12px" }}>
                                  <span
                                    style={{
                                      background: pill.bg,
                                      color: pill.fg,
                                      fontSize: "12px",
                                      fontWeight: 600,
                                      padding: "4px 10px",
                                      borderRadius: "100px",
                                    }}
                                  >
                                    {state}
                                  </span>
                                  {lg?.lsp?.name ? (
                                    <span style={{ fontSize: "13px", color: "#6B6B6B" }}>via {lg.lsp.name}</span>
                                  ) : null}
                                </div>
                              </div>

                              {/* Pickup / Drop-off */}
                              <div
                                style={{
                                  padding: "16px 20px 4px",
                                  display: "grid",
                                  gridTemplateColumns: "1fr 1fr",
                                  gap: "12px",
                                }}
                              >
                                <div style={{ background: "#FAFAFA", borderRadius: "10px", padding: "12px" }}>
                                  <p style={{ fontSize: "11px", color: "#9A9A9A", margin: "0 0 8px" }}>PICKUP LOCATION</p>
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                                    <div
                                      style={{
                                        width: "28px",
                                        height: "28px",
                                        borderRadius: "50%",
                                        background: "#E6F1FB",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                      }}
                                    >
                                      <FaTruck style={{ fontSize: "13px", color: "#185FA5" }} />
                                    </div>
                                    <p style={{ fontSize: "13px", fontWeight: 600, margin: 0 }}>{pickupName}</p>
                                  </div>
                                  {pickupAddr ? (
                                    <p style={{ fontSize: "12px", color: "#6B6B6B", margin: "0 0 4px", lineHeight: 1.4 }}>{pickupAddr}</p>
                                  ) : null}
                                  {pickupPhone ? (
                                    <p style={{ fontSize: "12px", color: "#6B6B6B", margin: 0, fontFamily: "monospace" }}>{pickupPhone}</p>
                                  ) : null}
                                </div>

                                <div style={{ background: "#FAFAFA", borderRadius: "10px", padding: "12px" }}>
                                  <p style={{ fontSize: "11px", color: "#9A9A9A", margin: "0 0 8px" }}>DROP-OFF LOCATION</p>
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                                    <div
                                      style={{
                                        width: "28px",
                                        height: "28px",
                                        borderRadius: "50%",
                                        background: "#E6F1FB",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexShrink: 0,
                                      }}
                                    >
                                      <FaMapMarkerAlt style={{ fontSize: "13px", color: "#185FA5" }} />
                                    </div>
                                    <p style={{ fontSize: "13px", fontWeight: 600, margin: 0 }}>{dropName}</p>
                                  </div>
                                  {dropAddr ? (
                                    <p style={{ fontSize: "12px", color: "#6B6B6B", margin: "0 0 4px", lineHeight: 1.4 }}>{dropAddr}</p>
                                  ) : null}
                                  {dropPhone ? (
                                    <p style={{ fontSize: "12px", color: "#6B6B6B", margin: 0, fontFamily: "monospace" }}>{dropPhone}</p>
                                  ) : null}
                                </div>
                              </div>

                              {/* Fees */}
                              <div style={{ padding: "16px 20px" }}>
                                <div style={{ background: "#FAFAFA", borderRadius: "10px", padding: "12px 14px" }}>
                                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "6px" }}>
                                    <span style={{ color: "#6B6B6B" }}>LSP fee</span>
                                    <span>₹{lg?.fees?.lsp ?? lg?.price ?? "-"}</span>
                                  </div>
                                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: "8px" }}>
                                    <span style={{ color: "#6B6B6B" }}>Platform fee</span>
                                    <span>₹{lg?.fees?.platform ?? "0"}</span>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      borderTop: "1px solid #E0E0E0",
                                      paddingTop: "8px",
                                    }}
                                  >
                                    <span>Total (incl. tax)</span>
                                    <span>₹{lg?.fees?.total_with_tax ?? lg?.price ?? "-"}</span>
                                  </div>
                                </div>
                              </div>

                              {/* Cancellation */}
                              {cancellation?.reason_desc ? (
                                <div style={{ padding: "0 20px 8px" }}>
                                  <div style={{ background: "#FDF2F2", borderRadius: "10px", padding: "12px 14px" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", marginBottom: cancellation?.cancelled_by ? "6px" : 0, gap: "12px" }}>
                                      <span style={{ color: "#6B6B6B" }}>Cancel reason</span>
                                      <span style={{ textAlign: "right", color: "#B91C1C" }}>{cancellation.reason_desc}</span>
                                    </div>
                                    {cancellation?.cancelled_by ? (
                                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "13px" }}>
                                        <span style={{ color: "#6B6B6B" }}>Cancelled by</span>
                                        <span>{cancellation.cancelled_by}</span>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              ) : null}

                              {/* Actions */}
                              <div style={{ padding: "8px 20px 20px", display: "flex", gap: "10px" }}>
                                {lg?.tracking_url ? (
                                  <button
                                    type="button"
                                    className="btn"
                                    style={{
                                      flex: 1,
                                      backgroundColor: "transparent",
                                      color: "#2C2C2A",
                                      border: "1px solid #E0E0E0",
                                      borderRadius: "10px",
                                      padding: "10px 20px",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => window.open(lg.tracking_url, "_blank", "noopener,noreferrer")}
                                  >
                                    <FaExternalLinkAlt style={{ fontSize: "12px", marginRight: "6px" }} />
                                    Track
                                  </button>
                                ) : null}
                                <button
                                  type="button"
                                  className="btn"
                                  style={{
                                    flex: 1,
                                    backgroundColor: "#DC3545",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "10px",
                                    padding: "10px 20px",
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => setShowLogisticEyeModal(false)}
                                >
                                  Close
                                </button>
                              </div>
                            </>
                          );
                        })()}
                      </Box>
                    </Modal>
                  </>

                  {WeightSection ? <div className="mt-3 dimensionMain" style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "16px" }}>
                    <strong className="text-info">Weight &amp; Dimensions</strong>
                    <div className="d-flex justify-content-center align-items-center" style={{ gap: "6px", width: "88%" }}>
                      Total Weight of Products:
                      <input type="number" style={{ width: "60%" }} name="weight" onChange={(e) => { WandChangeHandler(e) }} />
                      <select className="m-0" value={wAndD.weightUnit} name="weightUnit" onChange={(e) => { WandChangeHandler(e) }}>
                        <option value="">Select Unit</option>
                        <option value="Gram">Gram</option>
                        <option value="Kilogram">Kilogram</option>
                      </select>
                    </div>
                    <div className="d-flex justify-content-between mb-3" style={{ gap: "3px", width: "88%" }}>
                      Dimensions:
                      <select name="dimensionUnit" value={wAndD.dimensionUnit} onChange={(e) => { WandChangeHandler(e) }}>
                        <option value="">Select Unit</option>
                        <option value="meter">Meter</option>
                        <option value="centimeter">Centimeter</option>
                        <option value="inch">Inch</option>
                      </select>
                    </div>
                    <div className="d-flex flex-column" style={{ gap: "3px", width: "88%" }}>
                      <div className="d-flex justify-content-between" style={{ gap: "10px" }}>
                        <label htmlFor="">Length</label> <input type="number" name="length" value={wAndD?.length} onChange={(e) => { WandChangeHandler(e) }} />
                      </div>
                      <div className="d-flex  justify-content-between" style={{ gap: "10px" }}>
                        <label htmlFor="">Width</label> <input type="number" name="width" value={wAndD?.width} onChange={(e) => { WandChangeHandler(e) }} />
                      </div>
                      <div className="d-flex  justify-content-between" style={{ gap: "10px" }}>
                        <label htmlFor="">Height</label> <input type="number" name="height" value={wAndD?.height} onChange={(e) => { WandChangeHandler(e) }} />
                      </div>
                      <div className="d-flex justify-content-center">
                        <Pbutton onClick={getProvidersPayload} disabled={wAndD?.height !== "" ? false : true} style={{ color: "white", cursor: "pointer", marginTop: "10px" }}>Search Providers</Pbutton>
                      </div>
                    </div>
                  </div> : null}

                  <button className="btn btn-success col-md-3 d-none" onClick={getShipmentStatus}>{shipmentStatusLoading ? <CircularProgress style={{ color: "white" }} size={20} /> : "Get Shipment Status"} </button>
                </div>
                )}

                {/* Delivery Rider — Off Network */}
                {!networkLogistics && !isCancelledOrder && (
                <div style={S.card}>
                  <div style={{ marginBottom: "16px" }}>
                    <SectionTitle>Delivery Rider</SectionTitle>
                  </div>

                  {riderLoading ? (
                    <div style={{ fontSize: "13px", color: palette.subtext, marginBottom: "12px" }}>Loading rider…</div>
                  ) : assignedRider ? (
                    <div style={{ marginBottom: "12px", background: "#f6f7fb", border: `1px solid ${palette.border}`, borderRadius: "8px", padding: "14px 16px" }}>
                      <div style={S.rowLine}>
                        <span style={S.rowLabel}>Assigned rider</span>
                        <span style={S.rowValue}>{assignedRider.rider_name || assignedRider.name || "—"}</span>
                      </div>
                      <div style={{ ...S.rowLine, borderBottom: "none" }}>
                        <span style={S.rowLabel}>WhatsApp number</span>
                        <span style={S.rowValue}>{assignedRider.rider_whatsapp_number || assignedRider.whatsapp_number || assignedRider.rider_phone || assignedRider.phone || "—"}</span>
                      </div>
                    </div>
                  ) : (
                    <div style={{ fontSize: "13px", color: palette.subtext, marginBottom: "12px" }}>No rider assigned yet.</div>
                  )}

                  {!isCompletedOrder && (
                    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "flex-end" }}>
                      <div style={{ flex: "1 1 260px" }}>
                        <label style={S.fieldLabel}>{assignedRider ? "Reassign rider" : "Assign rider"}</label>
                        <select
                          style={S.select}
                          value={selectedRiderId}
                          onChange={(e) => setSelectedRiderId(e.target.value)}
                        >
                          <option value="">{riderListLoading ? "Loading riders..." : "Select a rider"}</option>
                          {riderList.map((r) => (
                            <option key={r.id ?? r.rider_id} value={r.id ?? r.rider_id}>
                              {r.name}{r.whatsapp_number ? ` (${r.whatsapp_number})` : ""}
                            </option>
                          ))}
                        </select>
                      </div>
                      <button style={S.primaryBtn} onClick={assignRiderHandler} disabled={!selectedRiderId || assigningRider}>
                        {assigningRider ? "Assigning..." : assignedRider ? "Reassign rider" : "Assign rider"}
                      </button>
                    </div>
                  )}
                </div>
                )}

                {/* Order details */}
                <div style={S.card}>
                  <SectionTitle>Order details</SectionTitle>
                  <div style={S.rowLine}><span style={S.rowLabel}>Order number</span><span style={S.rowValue}>{_orderDetail?.order_id}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Bill number</span><span style={S.rowValue}>GST {_orderDetail?.order_id?.slice(11, 17)}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Bill date</span><span style={S.rowValue}>{moment.utc(_orderDetail?.billing_address?.created_at).format("DD-MM-YYYY HH:mm:ss")}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Customer name</span><span style={S.rowValue}>{_orderDetail?.name}</span></div>

                  {logisticCharges?.breakup?.length === 3 && (
                    <>
                      <div style={S.rowLine}><span style={S.rowLabel}>Delivery charges</span><span style={S.rowValue}>{logisticCharges?.breakup[logisticCharges?.breakup.length - 2]?.price?.value}</span></div>
                      <div style={S.rowLine}><span style={S.rowLabel}>Packing charges</span><span style={S.rowValue}>{logisticCharges?.breakup[logisticCharges?.breakup.length - 1]?.price?.value}</span></div>
                    </>
                  )}
                  {logisticCharges?.breakup?.length === 2 && (
                    <div style={S.rowLine}><span style={S.rowLabel}>Delivery charges</span><span style={S.rowValue}>{logisticCharges?.breakup[logisticCharges?.breakup.length - 1]?.price?.value}</span></div>
                  )}

                  <div style={S.rowLine}><span style={S.rowLabel}>Total amount</span><span style={S.rowValue}>{_orderDetail?.total_price}</span></div>
                  {_orderDetail?.return_amount !== 0 && (
                    <div style={S.rowLine}><span style={S.rowLabel}>Cancel return amount</span><span style={S.rowValue}>{_orderDetail?.return_amount}</span></div>
                  )}
                  <div style={{ ...S.rowLine, borderBottom: "none", borderRadius: "5px" }}>
                    <span style={{ ...S.rowLabel, color: palette.teal, fontWeight: 700 }}>Grand total</span>
                    <span style={{ ...S.rowValue, color: palette.teal }}>{grandTotalValue}</span>
                  </div>
                </div>

                {/* Payment method */}
                <div style={S.card}>
                  <SectionTitle>Payment method</SectionTitle>
                  <div style={S.rowLine}><span style={S.rowLabel}>Order number</span><span style={S.rowValue}>{_orderDetail?.order_id?.slice(11, 17)}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Bill date</span><span style={S.rowValue}>{moment.utc(_orderDetail?.billing_address?.created_at).format("DD-MM-YYYY HH:mm:ss")}</span></div>
                  <div style={{ ...S.rowLine, borderBottom: "none" }}><span style={S.rowLabel}>Total amount</span><span style={S.rowValue}>{_orderDetail?.order_total}</span></div>
                </div>

                {/* Shipping address */}
                <div style={S.card}>
                  <SectionTitle>Shipping address</SectionTitle>
                  <div style={S.rowLine}><span style={S.rowLabel}>Name</span><span style={S.rowValue}>{_orderDetail?.billing_address?.name}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Email</span><span style={S.rowValue}>{_orderDetail?.billing_address?.email}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Mobile number</span><span style={S.rowValue}>{_orderDetail?.billing_address?.phone}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Address</span><span style={S.rowValue}>{_orderDetail?.billing_address?.address?.building}, {_orderDetail?.billing_address?.address?.locality}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>City</span><span style={S.rowValue}>{_orderDetail?.billing_address?.address?.city}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>State</span><span style={S.rowValue}>{_orderDetail?.billing_address?.address?.state}</span></div>
                  <div style={S.rowLine}><span style={S.rowLabel}>Country</span><span style={S.rowValue}>{_orderDetail?.billing_address?.address?.country}</span></div>
                  <div style={{ ...S.rowLine, borderBottom: "none" }}><span style={S.rowLabel}>Pin code</span><span style={S.rowValue}>{_orderDetail?.billing_address?.address?.area_code}</span></div>
                </div>

                {/* Logistics details address (on-network only) */}
                {_orderDetail?.on_network && (
                  <div style={S.card}>
                    <SectionTitle>Logistics details address</SectionTitle>
                    <div style={S.rowLine}><span style={S.rowLabel}>Logistics provider name</span><span style={S.rowValue}>{_orderDetail?.shipping_address[0]?.["@ondc/org/provider_name"]}</span></div>
                    <div style={S.rowLine}><span style={S.rowLabel}>Pickup OTP</span><span style={S.rowValue}>{_orderDetail?.shipping_address[0]?.["start"]?.["instructions"]?.["short_desc"]}</span></div>
                    <div style={S.rowLine}><span style={S.rowLabel}>Pickup instruction</span><span style={S.rowValue}>{_orderDetail?.shipping_address[0]?.["start"]?.["instructions"]?.["long_desc"]}</span></div>
                    <div style={S.rowLine}><span style={S.rowLabel}>Delivery OTP</span><span style={S.rowValue}>{_orderDetail?.shipping_address[0]?.["end"]?.["instructions"]?.["short_desc"]}</span></div>
                    <div style={S.rowLine}><span style={S.rowLabel}>Delivery instruction</span><span style={S.rowValue}>{_orderDetail?.shipping_address[0]?.["end"]?.["instructions"]?.["long_desc"]}</span></div>
                    <div style={S.rowLine}><span style={S.rowLabel}>Expected pickup time</span><span style={S.rowValue}>{moment.utc(_orderDetail?.shipping_address[0]?.["start"]?.["time"]?.range?.start).format("DD MMM YYYY, hh:mm A")}</span></div>
                    <div style={{ ...S.rowLine, borderBottom: "none" }}><span style={S.rowLabel}>Expected delivery time</span><span style={S.rowValue}>{moment.utc(_orderDetail?.shipping_address[0]?.["end"]?.["time"]?.range?.start).format("DD MMM YYYY, hh:mm A")}</span></div>
                  </div>
                )}

                {/* Invoice */}
                <div style={S.card}>
                  <SectionTitle>Invoice</SectionTitle>
                  <div className="d-flex justify-content-center align-items-center flex-wrap" style={{ gap: "20px" }}>
                    <button onClick={PDFGenerator} style={S.primaryBtn}>System generated invoice</button>
                    {/* <p className="m-0" style={{ color: palette.subtext }}>OR</p>

                    {invoiceHolder.origin === "database" && (
                      <a href={invoiceHolder?.path} target="_blank" style={{ textDecoration: "underline", color: palette.indigo, fontWeight: 600 }}>Store invoice</a>
                    )} */}

                    {/* {invoiceHolder.origin === "manual" && (
                      <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <label className="m-0" style={S.fieldLabel}>Upload Invoice</label>
                        <input type="file" className="form-control" accept="image/*" name="upload_pdf"
                          onChange={(e) => PdfHandler(e)} style={{ width: "220px" }}
                        />
                        <button className="btn btn-sm" style={S.primaryBtn} onClick={saveInvoice}>Save</button>
                      </div>
                    )} */}
                  </div>
                  <div style={{ display: "none" }}>
                    <Invoice orderId={order_id} />
                  </div>
                </div>

              </div>

              {/* ===================== SIDEBAR ===================== */}
              <div style={S.sideCol}>
                <div style={S.grandBox}>
                  <div style={S.grandLabel}>GRAND TOTAL</div>
                  <div style={S.grandValue}>₹{grandTotalValue}</div>
                  <div style={S.grandSub}>{orderDetail?.length || 0} items · {_orderDetail?.name}</div>
                  <div style={S.statusPill}>{orderState?.order_state || "—"}</div>
                  <div style={S.grandRow}><span>Items subtotal</span><span>₹{_orderDetail?.total_price}</span></div>
                  <div style={S.grandRow}><span>Bill number</span><span>GST {_orderDetail?.order_id?.slice(11, 17)}</span></div>
                  <div style={S.grandRow}><span>Bill date</span><span>{moment.utc(_orderDetail?.billing_address?.created_at).format("DD-MM-YYYY")}</span></div>
                </div>

                {order?.update ? (
                  <div style={S.card}>
                    <SectionTitle>Quick actions</SectionTitle>
                    {/* {nextFulfillmentStep && orderState?.order_state !== "Cancelled" && (
                      <button
                        style={S.quickActionPrimary}
                        disabled={updatingFulfillment || !imeiSubmitted}
                        onClick={advanceFulfillment}
                      >
                        {updatingFulfillment ? "Updating..." : `Mark as ${stepDisplayName(nextFulfillmentStep)}`}
                      </button>
                    )} */}
                    {/* <button style={S.quickActionSecondary} onClick={sendStatusHandler} disabled={sendingOrderStatus}>
                      {sendingOrderStatus ? "Sending Staus..." : "Send order status"}
                    </button> */}
                    {!isCancelledOrder && !isCompletedOrder && (
                      <button style={S.quickActionDanger} onClick={cancelbtn}>Cancel order</button>
                    )}
                  </div>
                ) : null}

                <div style={S.card}>
                  <SectionTitle>Customer</SectionTitle>
                  <div style={S.customerRow}>
                    <span style={S.customerIcon}>@</span>
                    <div>
                      <div style={S.customerLabel}>{_orderDetail?.billing_address?.email}</div>
                      <div style={S.customerSub}>Email</div>
                    </div>
                  </div>
                  <div style={S.customerRow}>
                    <span style={S.customerIcon}>☎</span>
                    <div>
                      <div style={S.customerLabel}>{_orderDetail?.billing_address?.phone}</div>
                      <div style={S.customerSub}>Mobile number</div>
                    </div>
                  </div>
                  <div style={S.customerRow}>
                    <span style={S.customerIcon}>⌂</span>
                    <div>
                      <div style={S.customerLabel}>{_orderDetail?.billing_address?.address?.city}, {_orderDetail?.billing_address?.address?.state} {_orderDetail?.billing_address?.address?.area_code}</div>
                      <div style={S.customerSub}>Shipping address</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "90vh", width: "100%" }}><CircularProgress /></div>
        )}

        <>
          <Modal
            open={shipmentModalOpen}
            onClose={handleShipementModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={Sstyle}>

              <div className="d-flex justify-content-end">
                <span style={{ cursor: "pointer" }} onClick={() => {
                  setshipmentModalOpen(false)
                }}><CloseIcon /></span>
              </div>
              <div style={{ padding: "20px" }}>

                <Box sx={{ width: '100%' }}>
                  <Stepper activeStep={0} alternativeLabel>
                    {steps.map((label) => (
                      <Step key={label}>
                        <StepLabel >{label}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Box>
              </div>
            </Box>
          </Modal>
        </>

        <>
          <Modal
            open={providersModalOpen}
            onClose={() => setprovidersModalOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={PSstyle} className="providersModal">

              <ProviderContainer>
                <div className="d-flex flex-column align-items-center" >
                  <p style={{ position: "absolute", top: "5px", right: "10px", color: "black", cursor: "pointer", fontSize: "14px" }} onClick={() => {
                    setprovidersModalOpen(false)
                  }}><CloseIcon style={{ cursor: "pointer" }} /></p>
                  <h3 className="text-center mt-2" style={{ fontSize: "17px", color: "balck", fontWeight: "600" }}>Providers</h3>

                  <div className="w-100 d-flex flex-column align-items-center" style={{ gap: "13px", maxHeight: "320px", overflow: "scroll" }}>
                    {
                      providersData?.map((item, index) => {
                        if (index >= issChecked.length) {
                          setIssChecked(prevState => [
                            ...prevState,
                            { id: index, checked: false }
                          ]);
                        }

                        return <ListContainer key={index}>
                          <p style={{ color: "black" }}>Name: {item.bpp_descriptor_name}</p>
                          <p style={{ color: "black" }}>Category: {item.item.category_id}</p>
                          <p style={{ color: "black" }}>Item id: {item?.item?.id} </p>
                          <div style={{ color: "black" }} className="d-flex justify-content-between">Price:Rs{item.item.price.value}
                            <section>
                              <label htmlFor="" style={{
                                display: "inline-block",
                                marginLeft: "5px",
                                color: "black",
                              }}>Select</label>
                              <input type="radio" name="choose"
                                id=""
                                onChange={() => { selectLogisticProvider(item, index) }} style={{
                                  appearance: "none", marginRight: "5px",
                                  position: "relative",
                                  top: "2px",
                                  width: "13px",
                                  height: "13px",
                                  borderRadius: "10%",
                                  border: "1px solid blue",
                                  backgroundColor: issChecked[index]?.checked ? "blue" : "transparent",
                                  outline: "none",
                                  marginLeft: "3px"
                                }}
                              />
                            </section> </div>

                        </ListContainer>
                      })
                    }

                  </div>
                </div>
                <button onClick={submitSelectedProvider} className="btn btn-primary my-2 text-light col-md-2" >{isSelectingProviders ? <CircularProgress style={{ color: "white" }} size={20} /> : "Submit"}</button>

              </ProviderContainer>

            </Box>


          </Modal>

        </>
        <>
          <Modal
            open={isConfirmingProviders}

            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={PSstyle} className="providersModal">

              <ProviderContainer>
                <div className="d-flex flex-column align-items-center " style={{ height: "220px" }} >
                  <p style={{ position: "absolute", top: "5px", right: "10px", color: "black" }} onClick={() => {
                    setisConfirmingProviders(false)
                  }}><CloseIcon style={{ cursor: "pointer" }} /></p>
                  <h3 className="text-center mt-2" style={{ fontSize: "17px", color: "balck", fontWeight: "600" }}>Confirm Provider</h3>

                  <div className="w-100 d-flex flex-column mt-2" style={{ gap: "6px", maxHeight: "250px", overflow: "scroll" }}>

                    <p className="p-0 m-0"> <span style={textStyle1}> Provider Name:</span> <span className="ml-3"> {submitData?.descripter}</span></p>
                    <p className="p-0 m-0"> <span style={textStyle1}>Category: </span> <span className="ml-3">{submitData?.item?.category_id}</span> </p>
                    <p className="p-0 m-0"> <span style={textStyle1}>Price:</span>  <span className="ml-2">Rs. {submitData?.item?.price?.value}</span>  </p>

                  </div>
                  <div className="d-flex" style={{ gap: "13px" }}>
                    <button onClick={() => { onConfirmHandler(submitData) }} className="btn btn-primary col-md-8 mt-4">{isConfirmingProvider ? <CircularProgress style={{ color: "white" }} size={15} /> : "Confirm"}</button>

                    <button onClick={() => { updateLSP(submitData) }} className="btn btn-primary col-md-8  mt-4">{isUpdatingProvider ? <CircularProgress style={{ color: "white" }} size={15} /> : "Update"}</button>
                  </div>

                </div>
              </ProviderContainer>
            </Box>
          </Modal>

        </>
        <Snackbar open={showGreaterValueAlert} autoHideDuration={2000}>
          <Alert severity="error" sx={{ width: '100%' }}>
            Please fill correct quantity
          </Alert>
        </Snackbar>
        <Snackbar open={showEnterValueAlert} autoHideDuration={3000} >
          <Alert severity="error" sx={{ width: '100%' }}>
            Please enter cancel quantity and reason for cancel
          </Alert>
        </Snackbar>
        <Snackbar open={showCancelQuantityGreaterthenOrderQuantity} autoHideDuration={3000} >
          <Alert severity="error" sx={{ width: '100%' }}>
            Cancel Quantity Can't be grater then Order Quantity
          </Alert>
        </Snackbar>
      </ThemeMaker >
    </>
  );
};

export default orderDetail;
